/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsOfServiceRouteImport } from './routes/terms-of-service'
import { Route as SupportRouteImport } from './routes/support'
import { Route as ProCallbackRouteImport } from './routes/pro-callback'
import { Route as ProRouteImport } from './routes/pro'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as FeaturesRouteImport } from './routes/features'
import { Route as CourtOrderLanguageRouteImport } from './routes/court-order-language'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CoachesRouteImport } from './routes/coaches'
import { Route as AppRouteImport } from './routes/app'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PurchaseIndexRouteImport } from './routes/purchase/index'
import { Route as ProIndexRouteImport } from './routes/pro/index'
import { Route as ParentingPlanIndexRouteImport } from './routes/parenting-plan/index'
import { Route as CompareIndexRouteImport } from './routes/compare/index'
import { Route as ChildSupportCalculatorIndexRouteImport } from './routes/child-support-calculator/index'
import { Route as AuthIndexRouteImport } from './routes/auth/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as PurchaseSuccessRouteImport } from './routes/purchase/success'
import { Route as PurchaseCancelRouteImport } from './routes/purchase/cancel'
import { Route as ProDirectoryRouteImport } from './routes/pro/directory'
import { Route as ParentingPlanBuilderRouteImport } from './routes/parenting-plan/builder'
import { Route as ParentingPlanScheduleRouteImport } from './routes/parenting-plan/$schedule'
import { Route as LearnPractitionersRouteImport } from './routes/learn/practitioners'
import { Route as LearnCoparentsRouteImport } from './routes/learn/coparents'
import { Route as CompareCompetitorRouteImport } from './routes/compare/$competitor'
import { Route as ChildSupportCalculatorStateRouteImport } from './routes/child-support-calculator/$state'
import { Route as AuthSignUpRouteImport } from './routes/auth/sign-up'
import { Route as AuthSignInRouteImport } from './routes/auth/sign-in'
import { Route as AppSettingsRouteImport } from './routes/app/settings'
import { Route as AppNotificationsRouteImport } from './routes/app/notifications'
import { Route as AppChatRouteImport } from './routes/app/chat'
import { Route as AdminVaultRouteImport } from './routes/admin/vault'
import { Route as AdminToolsRouteImport } from './routes/admin/tools'
import { Route as AdminSeoRouteImport } from './routes/admin/seo'
import { Route as AdminPulseRouteImport } from './routes/admin/pulse'
import { Route as AdminProspectsRouteImport } from './routes/admin/prospects'
import { Route as AdminProfessionalsRouteImport } from './routes/admin/professionals'
import { Route as AdminProfessionalCodesRouteImport } from './routes/admin/professional-codes'
import { Route as AdminProInviteRemindersRouteImport } from './routes/admin/pro-invite-reminders'
import { Route as AdminPerformanceRouteImport } from './routes/admin/performance'
import { Route as AdminMetricsRouteImport } from './routes/admin/metrics'
import { Route as AdminJournalRouteImport } from './routes/admin/journal'
import { Route as AdminDripCampaignsRouteImport } from './routes/admin/drip-campaigns'
import { Route as AdminDirectoryProfilesRouteImport } from './routes/admin/directory-profiles'
import { Route as AdminCoachOutreachRouteImport } from './routes/admin/coach-outreach'
import { Route as AdminCoachEngagementRouteImport } from './routes/admin/coach-engagement'
import { Route as AdminChatsRouteImport } from './routes/admin/chats'
import { Route as AdminAttributionRouteImport } from './routes/admin/attribution'
import { Route as AdminAdsRouteImport } from './routes/admin/ads'
import { Route as AppJournalIndexRouteImport } from './routes/app/journal/index'
import { Route as AppExpensesIndexRouteImport } from './routes/app/expenses/index'
import { Route as AppCalendarIndexRouteImport } from './routes/app/calendar/index'
import { Route as AdminProfessionalsIndexRouteImport } from './routes/admin/professionals/index'
import { Route as AdminDripCampaignsIndexRouteImport } from './routes/admin/drip-campaigns/index'
import { Route as RedeemProCodeRouteImport } from './routes/redeem/pro/$code'
import { Route as ProClientsInviteIdRouteImport } from './routes/pro/clients/$inviteId'
import { Route as AuthProSignUpRouteImport } from './routes/auth/pro/sign-up'
import { Route as AuthProSignInRouteImport } from './routes/auth/pro/sign-in'
import { Route as AppVaultBeneficiaryIdRouteImport } from './routes/app/vault/$beneficiaryId'
import { Route as AppPaymentsRecordRouteImport } from './routes/app/payments/record'
import { Route as AppPaymentsIdRouteImport } from './routes/app/payments/$id'
import { Route as AppOnboardingWelcomeRouteImport } from './routes/app/onboarding/welcome'
import { Route as AppOnboardingSocialProofRouteImport } from './routes/app/onboarding/social-proof'
import { Route as AppOnboardingSituationRouteImport } from './routes/app/onboarding/situation'
import { Route as AppOnboardingProfileRouteImport } from './routes/app/onboarding/profile'
import { Route as AppOnboardingPainPointRouteImport } from './routes/app/onboarding/pain-point'
import { Route as AppOnboardingInviteRouteImport } from './routes/app/onboarding/invite'
import { Route as AppOnboardingGoalsRouteImport } from './routes/app/onboarding/goals'
import { Route as AppOnboardingCurrentToolsRouteImport } from './routes/app/onboarding/current-tools'
import { Route as AppOnboardingChildrenCountRouteImport } from './routes/app/onboarding/children-count'
import { Route as AppOnboardingChildrenRouteImport } from './routes/app/onboarding/children'
import { Route as AppOnboardingBuildingPlanRouteImport } from './routes/app/onboarding/building-plan'
import { Route as AppJournalRecordRouteImport } from './routes/app/journal/record'
import { Route as AppJournalEntryIdRouteImport } from './routes/app/journal/$entryId'
import { Route as AppExpensesRecordRouteImport } from './routes/app/expenses/record'
import { Route as AppExpensesIdRouteImport } from './routes/app/expenses/$id'
import { Route as AppChatMainRouteImport } from './routes/app/chat/main'
import { Route as AppCalendarLogExchangeRouteImport } from './routes/app/calendar/log-exchange'
import { Route as AppCalendarComplianceRouteImport } from './routes/app/calendar/compliance'
import { Route as AppCalendarCheckInsRouteImport } from './routes/app/calendar/check-ins'
import { Route as AppCalendarAddScheduleRouteImport } from './routes/app/calendar/add-schedule'
import { Route as AppCalendarAddExceptionRouteImport } from './routes/app/calendar/add-exception'
import { Route as AppCalendarAddCheckInRouteImport } from './routes/app/calendar/add-check-in'
import { Route as AppCalendarScheduleIdRouteImport } from './routes/app/calendar/$scheduleId'
import { Route as AdminUsersUserIdRouteImport } from './routes/admin/users/$userId'
import { Route as AdminProfessionalsInvitesRouteImport } from './routes/admin/professionals/invites'
import { Route as AdminProfessionalsEngagementRouteImport } from './routes/admin/professionals/engagement'
import { Route as AdminProfessionalsCodesRouteImport } from './routes/admin/professionals/codes'
import { Route as AdminDripCampaignsRetentionRouteImport } from './routes/admin/drip-campaigns/retention'
import { Route as AdminDripCampaignsProspectsRouteImport } from './routes/admin/drip-campaigns/prospects'
import { Route as AdminDripCampaignsGrowthRouteImport } from './routes/admin/drip-campaigns/growth'
import { Route as AdminDripCampaignsConversionRouteImport } from './routes/admin/drip-campaigns/conversion'
import { Route as AdminDripCampaignsActivationRouteImport } from './routes/admin/drip-campaigns/activation'
import { Route as ProClientsInviteIdIndexRouteImport } from './routes/pro/clients/$inviteId/index'
import { Route as AdminUsersUserIdIndexRouteImport } from './routes/admin/users/$userId/index'
import { Route as ProClientsInviteIdJournalRouteImport } from './routes/pro/clients/$inviteId/journal'
import { Route as ProClientsInviteIdExpensesRouteImport } from './routes/pro/clients/$inviteId/expenses'
import { Route as ProClientsInviteIdChatRouteImport } from './routes/pro/clients/$inviteId/chat'
import { Route as ProClientsInviteIdCalendarRouteImport } from './routes/pro/clients/$inviteId/calendar'
import { Route as AppChatPaymentDisputeIdRouteImport } from './routes/app/chat/payment/$disputeId'
import { Route as AppChatExpenseDisputeIdRouteImport } from './routes/app/chat/expense/$disputeId'
import { Route as AppChatCustomChatIdRouteImport } from './routes/app/chat/custom/$chatId'
import { Route as AppCalendarEventsAddRouteImport } from './routes/app/calendar/events.add'
import { Route as AppCalendarEventsEventIdRouteImport } from './routes/app/calendar/events.$eventId'
import { Route as AdminUsersUserIdToolsRouteImport } from './routes/admin/users/$userId/tools'
import { Route as AdminUsersUserIdJournalRouteImport } from './routes/admin/users/$userId/journal'
import { Route as AdminUsersUserIdHouseholdsRouteImport } from './routes/admin/users/$userId/households'
import { Route as AdminUsersUserIdExportsRouteImport } from './routes/admin/users/$userId/exports'
import { Route as AdminUsersUserIdExpensesRouteImport } from './routes/admin/users/$userId/expenses'
import { Route as AdminUsersUserIdChatRouteImport } from './routes/admin/users/$userId/chat'
import { Route as AdminUsersUserIdAuditRouteImport } from './routes/admin/users/$userId/audit'
import { Route as AdminUsersUserIdActionsRouteImport } from './routes/admin/users/$userId/actions'

const TermsOfServiceRoute = TermsOfServiceRouteImport.update({
  id: '/terms-of-service',
  path: '/terms-of-service',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportRoute = SupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => rootRouteImport,
} as any)
const ProCallbackRoute = ProCallbackRouteImport.update({
  id: '/pro-callback',
  path: '/pro-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const ProRoute = ProRouteImport.update({
  id: '/pro',
  path: '/pro',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const FeaturesRoute = FeaturesRouteImport.update({
  id: '/features',
  path: '/features',
  getParentRoute: () => rootRouteImport,
} as any)
const CourtOrderLanguageRoute = CourtOrderLanguageRouteImport.update({
  id: '/court-order-language',
  path: '/court-order-language',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const CoachesRoute = CoachesRouteImport.update({
  id: '/coaches',
  path: '/coaches',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PurchaseIndexRoute = PurchaseIndexRouteImport.update({
  id: '/purchase/',
  path: '/purchase/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProIndexRoute = ProIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProRoute,
} as any)
const ParentingPlanIndexRoute = ParentingPlanIndexRouteImport.update({
  id: '/parenting-plan/',
  path: '/parenting-plan/',
  getParentRoute: () => rootRouteImport,
} as any)
const CompareIndexRoute = CompareIndexRouteImport.update({
  id: '/compare/',
  path: '/compare/',
  getParentRoute: () => rootRouteImport,
} as any)
const ChildSupportCalculatorIndexRoute =
  ChildSupportCalculatorIndexRouteImport.update({
    id: '/child-support-calculator/',
    path: '/child-support-calculator/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/auth/',
  path: '/auth/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const PurchaseSuccessRoute = PurchaseSuccessRouteImport.update({
  id: '/purchase/success',
  path: '/purchase/success',
  getParentRoute: () => rootRouteImport,
} as any)
const PurchaseCancelRoute = PurchaseCancelRouteImport.update({
  id: '/purchase/cancel',
  path: '/purchase/cancel',
  getParentRoute: () => rootRouteImport,
} as any)
const ProDirectoryRoute = ProDirectoryRouteImport.update({
  id: '/directory',
  path: '/directory',
  getParentRoute: () => ProRoute,
} as any)
const ParentingPlanBuilderRoute = ParentingPlanBuilderRouteImport.update({
  id: '/parenting-plan/builder',
  path: '/parenting-plan/builder',
  getParentRoute: () => rootRouteImport,
} as any)
const ParentingPlanScheduleRoute = ParentingPlanScheduleRouteImport.update({
  id: '/parenting-plan/$schedule',
  path: '/parenting-plan/$schedule',
  getParentRoute: () => rootRouteImport,
} as any)
const LearnPractitionersRoute = LearnPractitionersRouteImport.update({
  id: '/learn/practitioners',
  path: '/learn/practitioners',
  getParentRoute: () => rootRouteImport,
} as any)
const LearnCoparentsRoute = LearnCoparentsRouteImport.update({
  id: '/learn/coparents',
  path: '/learn/coparents',
  getParentRoute: () => rootRouteImport,
} as any)
const CompareCompetitorRoute = CompareCompetitorRouteImport.update({
  id: '/compare/$competitor',
  path: '/compare/$competitor',
  getParentRoute: () => rootRouteImport,
} as any)
const ChildSupportCalculatorStateRoute =
  ChildSupportCalculatorStateRouteImport.update({
    id: '/child-support-calculator/$state',
    path: '/child-support-calculator/$state',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthSignUpRoute = AuthSignUpRouteImport.update({
  id: '/auth/sign-up',
  path: '/auth/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/auth/sign-in',
  path: '/auth/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppNotificationsRoute = AppNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AppRoute,
} as any)
const AppChatRoute = AppChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => AppRoute,
} as any)
const AdminVaultRoute = AdminVaultRouteImport.update({
  id: '/vault',
  path: '/vault',
  getParentRoute: () => AdminRoute,
} as any)
const AdminToolsRoute = AdminToolsRouteImport.update({
  id: '/tools',
  path: '/tools',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSeoRoute = AdminSeoRouteImport.update({
  id: '/seo',
  path: '/seo',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPulseRoute = AdminPulseRouteImport.update({
  id: '/pulse',
  path: '/pulse',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProspectsRoute = AdminProspectsRouteImport.update({
  id: '/prospects',
  path: '/prospects',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProfessionalsRoute = AdminProfessionalsRouteImport.update({
  id: '/professionals',
  path: '/professionals',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProfessionalCodesRoute = AdminProfessionalCodesRouteImport.update({
  id: '/professional-codes',
  path: '/professional-codes',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProInviteRemindersRoute = AdminProInviteRemindersRouteImport.update({
  id: '/pro-invite-reminders',
  path: '/pro-invite-reminders',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPerformanceRoute = AdminPerformanceRouteImport.update({
  id: '/performance',
  path: '/performance',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMetricsRoute = AdminMetricsRouteImport.update({
  id: '/metrics',
  path: '/metrics',
  getParentRoute: () => AdminRoute,
} as any)
const AdminJournalRoute = AdminJournalRouteImport.update({
  id: '/journal',
  path: '/journal',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDripCampaignsRoute = AdminDripCampaignsRouteImport.update({
  id: '/drip-campaigns',
  path: '/drip-campaigns',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDirectoryProfilesRoute = AdminDirectoryProfilesRouteImport.update({
  id: '/directory-profiles',
  path: '/directory-profiles',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCoachOutreachRoute = AdminCoachOutreachRouteImport.update({
  id: '/coach-outreach',
  path: '/coach-outreach',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCoachEngagementRoute = AdminCoachEngagementRouteImport.update({
  id: '/coach-engagement',
  path: '/coach-engagement',
  getParentRoute: () => AdminRoute,
} as any)
const AdminChatsRoute = AdminChatsRouteImport.update({
  id: '/chats',
  path: '/chats',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAttributionRoute = AdminAttributionRouteImport.update({
  id: '/attribution',
  path: '/attribution',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAdsRoute = AdminAdsRouteImport.update({
  id: '/ads',
  path: '/ads',
  getParentRoute: () => AdminRoute,
} as any)
const AppJournalIndexRoute = AppJournalIndexRouteImport.update({
  id: '/journal/',
  path: '/journal/',
  getParentRoute: () => AppRoute,
} as any)
const AppExpensesIndexRoute = AppExpensesIndexRouteImport.update({
  id: '/expenses/',
  path: '/expenses/',
  getParentRoute: () => AppRoute,
} as any)
const AppCalendarIndexRoute = AppCalendarIndexRouteImport.update({
  id: '/calendar/',
  path: '/calendar/',
  getParentRoute: () => AppRoute,
} as any)
const AdminProfessionalsIndexRoute = AdminProfessionalsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminProfessionalsRoute,
} as any)
const AdminDripCampaignsIndexRoute = AdminDripCampaignsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminDripCampaignsRoute,
} as any)
const RedeemProCodeRoute = RedeemProCodeRouteImport.update({
  id: '/redeem/pro/$code',
  path: '/redeem/pro/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const ProClientsInviteIdRoute = ProClientsInviteIdRouteImport.update({
  id: '/clients/$inviteId',
  path: '/clients/$inviteId',
  getParentRoute: () => ProRoute,
} as any)
const AuthProSignUpRoute = AuthProSignUpRouteImport.update({
  id: '/auth/pro/sign-up',
  path: '/auth/pro/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthProSignInRoute = AuthProSignInRouteImport.update({
  id: '/auth/pro/sign-in',
  path: '/auth/pro/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AppVaultBeneficiaryIdRoute = AppVaultBeneficiaryIdRouteImport.update({
  id: '/vault/$beneficiaryId',
  path: '/vault/$beneficiaryId',
  getParentRoute: () => AppRoute,
} as any)
const AppPaymentsRecordRoute = AppPaymentsRecordRouteImport.update({
  id: '/payments/record',
  path: '/payments/record',
  getParentRoute: () => AppRoute,
} as any)
const AppPaymentsIdRoute = AppPaymentsIdRouteImport.update({
  id: '/payments/$id',
  path: '/payments/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppOnboardingWelcomeRoute = AppOnboardingWelcomeRouteImport.update({
  id: '/onboarding/welcome',
  path: '/onboarding/welcome',
  getParentRoute: () => AppRoute,
} as any)
const AppOnboardingSocialProofRoute =
  AppOnboardingSocialProofRouteImport.update({
    id: '/onboarding/social-proof',
    path: '/onboarding/social-proof',
    getParentRoute: () => AppRoute,
  } as any)
const AppOnboardingSituationRoute = AppOnboardingSituationRouteImport.update({
  id: '/onboarding/situation',
  path: '/onboarding/situation',
  getParentRoute: () => AppRoute,
} as any)
const AppOnboardingProfileRoute = AppOnboardingProfileRouteImport.update({
  id: '/onboarding/profile',
  path: '/onboarding/profile',
  getParentRoute: () => AppRoute,
} as any)
const AppOnboardingPainPointRoute = AppOnboardingPainPointRouteImport.update({
  id: '/onboarding/pain-point',
  path: '/onboarding/pain-point',
  getParentRoute: () => AppRoute,
} as any)
const AppOnboardingInviteRoute = AppOnboardingInviteRouteImport.update({
  id: '/onboarding/invite',
  path: '/onboarding/invite',
  getParentRoute: () => AppRoute,
} as any)
const AppOnboardingGoalsRoute = AppOnboardingGoalsRouteImport.update({
  id: '/onboarding/goals',
  path: '/onboarding/goals',
  getParentRoute: () => AppRoute,
} as any)
const AppOnboardingCurrentToolsRoute =
  AppOnboardingCurrentToolsRouteImport.update({
    id: '/onboarding/current-tools',
    path: '/onboarding/current-tools',
    getParentRoute: () => AppRoute,
  } as any)
const AppOnboardingChildrenCountRoute =
  AppOnboardingChildrenCountRouteImport.update({
    id: '/onboarding/children-count',
    path: '/onboarding/children-count',
    getParentRoute: () => AppRoute,
  } as any)
const AppOnboardingChildrenRoute = AppOnboardingChildrenRouteImport.update({
  id: '/onboarding/children',
  path: '/onboarding/children',
  getParentRoute: () => AppRoute,
} as any)
const AppOnboardingBuildingPlanRoute =
  AppOnboardingBuildingPlanRouteImport.update({
    id: '/onboarding/building-plan',
    path: '/onboarding/building-plan',
    getParentRoute: () => AppRoute,
  } as any)
const AppJournalRecordRoute = AppJournalRecordRouteImport.update({
  id: '/journal/record',
  path: '/journal/record',
  getParentRoute: () => AppRoute,
} as any)
const AppJournalEntryIdRoute = AppJournalEntryIdRouteImport.update({
  id: '/journal/$entryId',
  path: '/journal/$entryId',
  getParentRoute: () => AppRoute,
} as any)
const AppExpensesRecordRoute = AppExpensesRecordRouteImport.update({
  id: '/expenses/record',
  path: '/expenses/record',
  getParentRoute: () => AppRoute,
} as any)
const AppExpensesIdRoute = AppExpensesIdRouteImport.update({
  id: '/expenses/$id',
  path: '/expenses/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppChatMainRoute = AppChatMainRouteImport.update({
  id: '/main',
  path: '/main',
  getParentRoute: () => AppChatRoute,
} as any)
const AppCalendarLogExchangeRoute = AppCalendarLogExchangeRouteImport.update({
  id: '/calendar/log-exchange',
  path: '/calendar/log-exchange',
  getParentRoute: () => AppRoute,
} as any)
const AppCalendarComplianceRoute = AppCalendarComplianceRouteImport.update({
  id: '/calendar/compliance',
  path: '/calendar/compliance',
  getParentRoute: () => AppRoute,
} as any)
const AppCalendarCheckInsRoute = AppCalendarCheckInsRouteImport.update({
  id: '/calendar/check-ins',
  path: '/calendar/check-ins',
  getParentRoute: () => AppRoute,
} as any)
const AppCalendarAddScheduleRoute = AppCalendarAddScheduleRouteImport.update({
  id: '/calendar/add-schedule',
  path: '/calendar/add-schedule',
  getParentRoute: () => AppRoute,
} as any)
const AppCalendarAddExceptionRoute = AppCalendarAddExceptionRouteImport.update({
  id: '/calendar/add-exception',
  path: '/calendar/add-exception',
  getParentRoute: () => AppRoute,
} as any)
const AppCalendarAddCheckInRoute = AppCalendarAddCheckInRouteImport.update({
  id: '/calendar/add-check-in',
  path: '/calendar/add-check-in',
  getParentRoute: () => AppRoute,
} as any)
const AppCalendarScheduleIdRoute = AppCalendarScheduleIdRouteImport.update({
  id: '/calendar/$scheduleId',
  path: '/calendar/$scheduleId',
  getParentRoute: () => AppRoute,
} as any)
const AdminUsersUserIdRoute = AdminUsersUserIdRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProfessionalsInvitesRoute =
  AdminProfessionalsInvitesRouteImport.update({
    id: '/invites',
    path: '/invites',
    getParentRoute: () => AdminProfessionalsRoute,
  } as any)
const AdminProfessionalsEngagementRoute =
  AdminProfessionalsEngagementRouteImport.update({
    id: '/engagement',
    path: '/engagement',
    getParentRoute: () => AdminProfessionalsRoute,
  } as any)
const AdminProfessionalsCodesRoute = AdminProfessionalsCodesRouteImport.update({
  id: '/codes',
  path: '/codes',
  getParentRoute: () => AdminProfessionalsRoute,
} as any)
const AdminDripCampaignsRetentionRoute =
  AdminDripCampaignsRetentionRouteImport.update({
    id: '/retention',
    path: '/retention',
    getParentRoute: () => AdminDripCampaignsRoute,
  } as any)
const AdminDripCampaignsProspectsRoute =
  AdminDripCampaignsProspectsRouteImport.update({
    id: '/prospects',
    path: '/prospects',
    getParentRoute: () => AdminDripCampaignsRoute,
  } as any)
const AdminDripCampaignsGrowthRoute =
  AdminDripCampaignsGrowthRouteImport.update({
    id: '/growth',
    path: '/growth',
    getParentRoute: () => AdminDripCampaignsRoute,
  } as any)
const AdminDripCampaignsConversionRoute =
  AdminDripCampaignsConversionRouteImport.update({
    id: '/conversion',
    path: '/conversion',
    getParentRoute: () => AdminDripCampaignsRoute,
  } as any)
const AdminDripCampaignsActivationRoute =
  AdminDripCampaignsActivationRouteImport.update({
    id: '/activation',
    path: '/activation',
    getParentRoute: () => AdminDripCampaignsRoute,
  } as any)
const ProClientsInviteIdIndexRoute = ProClientsInviteIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProClientsInviteIdRoute,
} as any)
const AdminUsersUserIdIndexRoute = AdminUsersUserIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminUsersUserIdRoute,
} as any)
const ProClientsInviteIdJournalRoute =
  ProClientsInviteIdJournalRouteImport.update({
    id: '/journal',
    path: '/journal',
    getParentRoute: () => ProClientsInviteIdRoute,
  } as any)
const ProClientsInviteIdExpensesRoute =
  ProClientsInviteIdExpensesRouteImport.update({
    id: '/expenses',
    path: '/expenses',
    getParentRoute: () => ProClientsInviteIdRoute,
  } as any)
const ProClientsInviteIdChatRoute = ProClientsInviteIdChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => ProClientsInviteIdRoute,
} as any)
const ProClientsInviteIdCalendarRoute =
  ProClientsInviteIdCalendarRouteImport.update({
    id: '/calendar',
    path: '/calendar',
    getParentRoute: () => ProClientsInviteIdRoute,
  } as any)
const AppChatPaymentDisputeIdRoute = AppChatPaymentDisputeIdRouteImport.update({
  id: '/payment/$disputeId',
  path: '/payment/$disputeId',
  getParentRoute: () => AppChatRoute,
} as any)
const AppChatExpenseDisputeIdRoute = AppChatExpenseDisputeIdRouteImport.update({
  id: '/expense/$disputeId',
  path: '/expense/$disputeId',
  getParentRoute: () => AppChatRoute,
} as any)
const AppChatCustomChatIdRoute = AppChatCustomChatIdRouteImport.update({
  id: '/custom/$chatId',
  path: '/custom/$chatId',
  getParentRoute: () => AppChatRoute,
} as any)
const AppCalendarEventsAddRoute = AppCalendarEventsAddRouteImport.update({
  id: '/calendar/events/add',
  path: '/calendar/events/add',
  getParentRoute: () => AppRoute,
} as any)
const AppCalendarEventsEventIdRoute =
  AppCalendarEventsEventIdRouteImport.update({
    id: '/calendar/events/$eventId',
    path: '/calendar/events/$eventId',
    getParentRoute: () => AppRoute,
  } as any)
const AdminUsersUserIdToolsRoute = AdminUsersUserIdToolsRouteImport.update({
  id: '/tools',
  path: '/tools',
  getParentRoute: () => AdminUsersUserIdRoute,
} as any)
const AdminUsersUserIdJournalRoute = AdminUsersUserIdJournalRouteImport.update({
  id: '/journal',
  path: '/journal',
  getParentRoute: () => AdminUsersUserIdRoute,
} as any)
const AdminUsersUserIdHouseholdsRoute =
  AdminUsersUserIdHouseholdsRouteImport.update({
    id: '/households',
    path: '/households',
    getParentRoute: () => AdminUsersUserIdRoute,
  } as any)
const AdminUsersUserIdExportsRoute = AdminUsersUserIdExportsRouteImport.update({
  id: '/exports',
  path: '/exports',
  getParentRoute: () => AdminUsersUserIdRoute,
} as any)
const AdminUsersUserIdExpensesRoute =
  AdminUsersUserIdExpensesRouteImport.update({
    id: '/expenses',
    path: '/expenses',
    getParentRoute: () => AdminUsersUserIdRoute,
  } as any)
const AdminUsersUserIdChatRoute = AdminUsersUserIdChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => AdminUsersUserIdRoute,
} as any)
const AdminUsersUserIdAuditRoute = AdminUsersUserIdAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AdminUsersUserIdRoute,
} as any)
const AdminUsersUserIdActionsRoute = AdminUsersUserIdActionsRouteImport.update({
  id: '/actions',
  path: '/actions',
  getParentRoute: () => AdminUsersUserIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/app': typeof AppRouteWithChildren
  '/coaches': typeof CoachesRoute
  '/contact': typeof ContactRoute
  '/court-order-language': typeof CourtOrderLanguageRoute
  '/features': typeof FeaturesRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/pro': typeof ProRouteWithChildren
  '/pro-callback': typeof ProCallbackRoute
  '/support': typeof SupportRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/admin/ads': typeof AdminAdsRoute
  '/admin/attribution': typeof AdminAttributionRoute
  '/admin/chats': typeof AdminChatsRoute
  '/admin/coach-engagement': typeof AdminCoachEngagementRoute
  '/admin/coach-outreach': typeof AdminCoachOutreachRoute
  '/admin/directory-profiles': typeof AdminDirectoryProfilesRoute
  '/admin/drip-campaigns': typeof AdminDripCampaignsRouteWithChildren
  '/admin/journal': typeof AdminJournalRoute
  '/admin/metrics': typeof AdminMetricsRoute
  '/admin/performance': typeof AdminPerformanceRoute
  '/admin/pro-invite-reminders': typeof AdminProInviteRemindersRoute
  '/admin/professional-codes': typeof AdminProfessionalCodesRoute
  '/admin/professionals': typeof AdminProfessionalsRouteWithChildren
  '/admin/prospects': typeof AdminProspectsRoute
  '/admin/pulse': typeof AdminPulseRoute
  '/admin/seo': typeof AdminSeoRoute
  '/admin/tools': typeof AdminToolsRoute
  '/admin/vault': typeof AdminVaultRoute
  '/app/chat': typeof AppChatRouteWithChildren
  '/app/notifications': typeof AppNotificationsRoute
  '/app/settings': typeof AppSettingsRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/child-support-calculator/$state': typeof ChildSupportCalculatorStateRoute
  '/compare/$competitor': typeof CompareCompetitorRoute
  '/learn/coparents': typeof LearnCoparentsRoute
  '/learn/practitioners': typeof LearnPractitionersRoute
  '/parenting-plan/$schedule': typeof ParentingPlanScheduleRoute
  '/parenting-plan/builder': typeof ParentingPlanBuilderRoute
  '/pro/directory': typeof ProDirectoryRoute
  '/purchase/cancel': typeof PurchaseCancelRoute
  '/purchase/success': typeof PurchaseSuccessRoute
  '/admin/': typeof AdminIndexRoute
  '/auth': typeof AuthIndexRoute
  '/child-support-calculator': typeof ChildSupportCalculatorIndexRoute
  '/compare': typeof CompareIndexRoute
  '/parenting-plan': typeof ParentingPlanIndexRoute
  '/pro/': typeof ProIndexRoute
  '/purchase': typeof PurchaseIndexRoute
  '/admin/drip-campaigns/activation': typeof AdminDripCampaignsActivationRoute
  '/admin/drip-campaigns/conversion': typeof AdminDripCampaignsConversionRoute
  '/admin/drip-campaigns/growth': typeof AdminDripCampaignsGrowthRoute
  '/admin/drip-campaigns/prospects': typeof AdminDripCampaignsProspectsRoute
  '/admin/drip-campaigns/retention': typeof AdminDripCampaignsRetentionRoute
  '/admin/professionals/codes': typeof AdminProfessionalsCodesRoute
  '/admin/professionals/engagement': typeof AdminProfessionalsEngagementRoute
  '/admin/professionals/invites': typeof AdminProfessionalsInvitesRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRouteWithChildren
  '/app/calendar/$scheduleId': typeof AppCalendarScheduleIdRoute
  '/app/calendar/add-check-in': typeof AppCalendarAddCheckInRoute
  '/app/calendar/add-exception': typeof AppCalendarAddExceptionRoute
  '/app/calendar/add-schedule': typeof AppCalendarAddScheduleRoute
  '/app/calendar/check-ins': typeof AppCalendarCheckInsRoute
  '/app/calendar/compliance': typeof AppCalendarComplianceRoute
  '/app/calendar/log-exchange': typeof AppCalendarLogExchangeRoute
  '/app/chat/main': typeof AppChatMainRoute
  '/app/expenses/$id': typeof AppExpensesIdRoute
  '/app/expenses/record': typeof AppExpensesRecordRoute
  '/app/journal/$entryId': typeof AppJournalEntryIdRoute
  '/app/journal/record': typeof AppJournalRecordRoute
  '/app/onboarding/building-plan': typeof AppOnboardingBuildingPlanRoute
  '/app/onboarding/children': typeof AppOnboardingChildrenRoute
  '/app/onboarding/children-count': typeof AppOnboardingChildrenCountRoute
  '/app/onboarding/current-tools': typeof AppOnboardingCurrentToolsRoute
  '/app/onboarding/goals': typeof AppOnboardingGoalsRoute
  '/app/onboarding/invite': typeof AppOnboardingInviteRoute
  '/app/onboarding/pain-point': typeof AppOnboardingPainPointRoute
  '/app/onboarding/profile': typeof AppOnboardingProfileRoute
  '/app/onboarding/situation': typeof AppOnboardingSituationRoute
  '/app/onboarding/social-proof': typeof AppOnboardingSocialProofRoute
  '/app/onboarding/welcome': typeof AppOnboardingWelcomeRoute
  '/app/payments/$id': typeof AppPaymentsIdRoute
  '/app/payments/record': typeof AppPaymentsRecordRoute
  '/app/vault/$beneficiaryId': typeof AppVaultBeneficiaryIdRoute
  '/auth/pro/sign-in': typeof AuthProSignInRoute
  '/auth/pro/sign-up': typeof AuthProSignUpRoute
  '/pro/clients/$inviteId': typeof ProClientsInviteIdRouteWithChildren
  '/redeem/pro/$code': typeof RedeemProCodeRoute
  '/admin/drip-campaigns/': typeof AdminDripCampaignsIndexRoute
  '/admin/professionals/': typeof AdminProfessionalsIndexRoute
  '/app/calendar': typeof AppCalendarIndexRoute
  '/app/expenses': typeof AppExpensesIndexRoute
  '/app/journal': typeof AppJournalIndexRoute
  '/admin/users/$userId/actions': typeof AdminUsersUserIdActionsRoute
  '/admin/users/$userId/audit': typeof AdminUsersUserIdAuditRoute
  '/admin/users/$userId/chat': typeof AdminUsersUserIdChatRoute
  '/admin/users/$userId/expenses': typeof AdminUsersUserIdExpensesRoute
  '/admin/users/$userId/exports': typeof AdminUsersUserIdExportsRoute
  '/admin/users/$userId/households': typeof AdminUsersUserIdHouseholdsRoute
  '/admin/users/$userId/journal': typeof AdminUsersUserIdJournalRoute
  '/admin/users/$userId/tools': typeof AdminUsersUserIdToolsRoute
  '/app/calendar/events/$eventId': typeof AppCalendarEventsEventIdRoute
  '/app/calendar/events/add': typeof AppCalendarEventsAddRoute
  '/app/chat/custom/$chatId': typeof AppChatCustomChatIdRoute
  '/app/chat/expense/$disputeId': typeof AppChatExpenseDisputeIdRoute
  '/app/chat/payment/$disputeId': typeof AppChatPaymentDisputeIdRoute
  '/pro/clients/$inviteId/calendar': typeof ProClientsInviteIdCalendarRoute
  '/pro/clients/$inviteId/chat': typeof ProClientsInviteIdChatRoute
  '/pro/clients/$inviteId/expenses': typeof ProClientsInviteIdExpensesRoute
  '/pro/clients/$inviteId/journal': typeof ProClientsInviteIdJournalRoute
  '/admin/users/$userId/': typeof AdminUsersUserIdIndexRoute
  '/pro/clients/$inviteId/': typeof ProClientsInviteIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/coaches': typeof CoachesRoute
  '/contact': typeof ContactRoute
  '/court-order-language': typeof CourtOrderLanguageRoute
  '/features': typeof FeaturesRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/pro-callback': typeof ProCallbackRoute
  '/support': typeof SupportRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/admin/ads': typeof AdminAdsRoute
  '/admin/attribution': typeof AdminAttributionRoute
  '/admin/chats': typeof AdminChatsRoute
  '/admin/coach-engagement': typeof AdminCoachEngagementRoute
  '/admin/coach-outreach': typeof AdminCoachOutreachRoute
  '/admin/directory-profiles': typeof AdminDirectoryProfilesRoute
  '/admin/journal': typeof AdminJournalRoute
  '/admin/metrics': typeof AdminMetricsRoute
  '/admin/performance': typeof AdminPerformanceRoute
  '/admin/pro-invite-reminders': typeof AdminProInviteRemindersRoute
  '/admin/professional-codes': typeof AdminProfessionalCodesRoute
  '/admin/prospects': typeof AdminProspectsRoute
  '/admin/pulse': typeof AdminPulseRoute
  '/admin/seo': typeof AdminSeoRoute
  '/admin/tools': typeof AdminToolsRoute
  '/admin/vault': typeof AdminVaultRoute
  '/app/chat': typeof AppChatRouteWithChildren
  '/app/notifications': typeof AppNotificationsRoute
  '/app/settings': typeof AppSettingsRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/child-support-calculator/$state': typeof ChildSupportCalculatorStateRoute
  '/compare/$competitor': typeof CompareCompetitorRoute
  '/learn/coparents': typeof LearnCoparentsRoute
  '/learn/practitioners': typeof LearnPractitionersRoute
  '/parenting-plan/$schedule': typeof ParentingPlanScheduleRoute
  '/parenting-plan/builder': typeof ParentingPlanBuilderRoute
  '/pro/directory': typeof ProDirectoryRoute
  '/purchase/cancel': typeof PurchaseCancelRoute
  '/purchase/success': typeof PurchaseSuccessRoute
  '/admin': typeof AdminIndexRoute
  '/auth': typeof AuthIndexRoute
  '/child-support-calculator': typeof ChildSupportCalculatorIndexRoute
  '/compare': typeof CompareIndexRoute
  '/parenting-plan': typeof ParentingPlanIndexRoute
  '/pro': typeof ProIndexRoute
  '/purchase': typeof PurchaseIndexRoute
  '/admin/drip-campaigns/activation': typeof AdminDripCampaignsActivationRoute
  '/admin/drip-campaigns/conversion': typeof AdminDripCampaignsConversionRoute
  '/admin/drip-campaigns/growth': typeof AdminDripCampaignsGrowthRoute
  '/admin/drip-campaigns/prospects': typeof AdminDripCampaignsProspectsRoute
  '/admin/drip-campaigns/retention': typeof AdminDripCampaignsRetentionRoute
  '/admin/professionals/codes': typeof AdminProfessionalsCodesRoute
  '/admin/professionals/engagement': typeof AdminProfessionalsEngagementRoute
  '/admin/professionals/invites': typeof AdminProfessionalsInvitesRoute
  '/app/calendar/$scheduleId': typeof AppCalendarScheduleIdRoute
  '/app/calendar/add-check-in': typeof AppCalendarAddCheckInRoute
  '/app/calendar/add-exception': typeof AppCalendarAddExceptionRoute
  '/app/calendar/add-schedule': typeof AppCalendarAddScheduleRoute
  '/app/calendar/check-ins': typeof AppCalendarCheckInsRoute
  '/app/calendar/compliance': typeof AppCalendarComplianceRoute
  '/app/calendar/log-exchange': typeof AppCalendarLogExchangeRoute
  '/app/chat/main': typeof AppChatMainRoute
  '/app/expenses/$id': typeof AppExpensesIdRoute
  '/app/expenses/record': typeof AppExpensesRecordRoute
  '/app/journal/$entryId': typeof AppJournalEntryIdRoute
  '/app/journal/record': typeof AppJournalRecordRoute
  '/app/onboarding/building-plan': typeof AppOnboardingBuildingPlanRoute
  '/app/onboarding/children': typeof AppOnboardingChildrenRoute
  '/app/onboarding/children-count': typeof AppOnboardingChildrenCountRoute
  '/app/onboarding/current-tools': typeof AppOnboardingCurrentToolsRoute
  '/app/onboarding/goals': typeof AppOnboardingGoalsRoute
  '/app/onboarding/invite': typeof AppOnboardingInviteRoute
  '/app/onboarding/pain-point': typeof AppOnboardingPainPointRoute
  '/app/onboarding/profile': typeof AppOnboardingProfileRoute
  '/app/onboarding/situation': typeof AppOnboardingSituationRoute
  '/app/onboarding/social-proof': typeof AppOnboardingSocialProofRoute
  '/app/onboarding/welcome': typeof AppOnboardingWelcomeRoute
  '/app/payments/$id': typeof AppPaymentsIdRoute
  '/app/payments/record': typeof AppPaymentsRecordRoute
  '/app/vault/$beneficiaryId': typeof AppVaultBeneficiaryIdRoute
  '/auth/pro/sign-in': typeof AuthProSignInRoute
  '/auth/pro/sign-up': typeof AuthProSignUpRoute
  '/redeem/pro/$code': typeof RedeemProCodeRoute
  '/admin/drip-campaigns': typeof AdminDripCampaignsIndexRoute
  '/admin/professionals': typeof AdminProfessionalsIndexRoute
  '/app/calendar': typeof AppCalendarIndexRoute
  '/app/expenses': typeof AppExpensesIndexRoute
  '/app/journal': typeof AppJournalIndexRoute
  '/admin/users/$userId/actions': typeof AdminUsersUserIdActionsRoute
  '/admin/users/$userId/audit': typeof AdminUsersUserIdAuditRoute
  '/admin/users/$userId/chat': typeof AdminUsersUserIdChatRoute
  '/admin/users/$userId/expenses': typeof AdminUsersUserIdExpensesRoute
  '/admin/users/$userId/exports': typeof AdminUsersUserIdExportsRoute
  '/admin/users/$userId/households': typeof AdminUsersUserIdHouseholdsRoute
  '/admin/users/$userId/journal': typeof AdminUsersUserIdJournalRoute
  '/admin/users/$userId/tools': typeof AdminUsersUserIdToolsRoute
  '/app/calendar/events/$eventId': typeof AppCalendarEventsEventIdRoute
  '/app/calendar/events/add': typeof AppCalendarEventsAddRoute
  '/app/chat/custom/$chatId': typeof AppChatCustomChatIdRoute
  '/app/chat/expense/$disputeId': typeof AppChatExpenseDisputeIdRoute
  '/app/chat/payment/$disputeId': typeof AppChatPaymentDisputeIdRoute
  '/pro/clients/$inviteId/calendar': typeof ProClientsInviteIdCalendarRoute
  '/pro/clients/$inviteId/chat': typeof ProClientsInviteIdChatRoute
  '/pro/clients/$inviteId/expenses': typeof ProClientsInviteIdExpensesRoute
  '/pro/clients/$inviteId/journal': typeof ProClientsInviteIdJournalRoute
  '/admin/users/$userId': typeof AdminUsersUserIdIndexRoute
  '/pro/clients/$inviteId': typeof ProClientsInviteIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/app': typeof AppRouteWithChildren
  '/coaches': typeof CoachesRoute
  '/contact': typeof ContactRoute
  '/court-order-language': typeof CourtOrderLanguageRoute
  '/features': typeof FeaturesRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/pro': typeof ProRouteWithChildren
  '/pro-callback': typeof ProCallbackRoute
  '/support': typeof SupportRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/admin/ads': typeof AdminAdsRoute
  '/admin/attribution': typeof AdminAttributionRoute
  '/admin/chats': typeof AdminChatsRoute
  '/admin/coach-engagement': typeof AdminCoachEngagementRoute
  '/admin/coach-outreach': typeof AdminCoachOutreachRoute
  '/admin/directory-profiles': typeof AdminDirectoryProfilesRoute
  '/admin/drip-campaigns': typeof AdminDripCampaignsRouteWithChildren
  '/admin/journal': typeof AdminJournalRoute
  '/admin/metrics': typeof AdminMetricsRoute
  '/admin/performance': typeof AdminPerformanceRoute
  '/admin/pro-invite-reminders': typeof AdminProInviteRemindersRoute
  '/admin/professional-codes': typeof AdminProfessionalCodesRoute
  '/admin/professionals': typeof AdminProfessionalsRouteWithChildren
  '/admin/prospects': typeof AdminProspectsRoute
  '/admin/pulse': typeof AdminPulseRoute
  '/admin/seo': typeof AdminSeoRoute
  '/admin/tools': typeof AdminToolsRoute
  '/admin/vault': typeof AdminVaultRoute
  '/app/chat': typeof AppChatRouteWithChildren
  '/app/notifications': typeof AppNotificationsRoute
  '/app/settings': typeof AppSettingsRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/child-support-calculator/$state': typeof ChildSupportCalculatorStateRoute
  '/compare/$competitor': typeof CompareCompetitorRoute
  '/learn/coparents': typeof LearnCoparentsRoute
  '/learn/practitioners': typeof LearnPractitionersRoute
  '/parenting-plan/$schedule': typeof ParentingPlanScheduleRoute
  '/parenting-plan/builder': typeof ParentingPlanBuilderRoute
  '/pro/directory': typeof ProDirectoryRoute
  '/purchase/cancel': typeof PurchaseCancelRoute
  '/purchase/success': typeof PurchaseSuccessRoute
  '/admin/': typeof AdminIndexRoute
  '/auth/': typeof AuthIndexRoute
  '/child-support-calculator/': typeof ChildSupportCalculatorIndexRoute
  '/compare/': typeof CompareIndexRoute
  '/parenting-plan/': typeof ParentingPlanIndexRoute
  '/pro/': typeof ProIndexRoute
  '/purchase/': typeof PurchaseIndexRoute
  '/admin/drip-campaigns/activation': typeof AdminDripCampaignsActivationRoute
  '/admin/drip-campaigns/conversion': typeof AdminDripCampaignsConversionRoute
  '/admin/drip-campaigns/growth': typeof AdminDripCampaignsGrowthRoute
  '/admin/drip-campaigns/prospects': typeof AdminDripCampaignsProspectsRoute
  '/admin/drip-campaigns/retention': typeof AdminDripCampaignsRetentionRoute
  '/admin/professionals/codes': typeof AdminProfessionalsCodesRoute
  '/admin/professionals/engagement': typeof AdminProfessionalsEngagementRoute
  '/admin/professionals/invites': typeof AdminProfessionalsInvitesRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRouteWithChildren
  '/app/calendar/$scheduleId': typeof AppCalendarScheduleIdRoute
  '/app/calendar/add-check-in': typeof AppCalendarAddCheckInRoute
  '/app/calendar/add-exception': typeof AppCalendarAddExceptionRoute
  '/app/calendar/add-schedule': typeof AppCalendarAddScheduleRoute
  '/app/calendar/check-ins': typeof AppCalendarCheckInsRoute
  '/app/calendar/compliance': typeof AppCalendarComplianceRoute
  '/app/calendar/log-exchange': typeof AppCalendarLogExchangeRoute
  '/app/chat/main': typeof AppChatMainRoute
  '/app/expenses/$id': typeof AppExpensesIdRoute
  '/app/expenses/record': typeof AppExpensesRecordRoute
  '/app/journal/$entryId': typeof AppJournalEntryIdRoute
  '/app/journal/record': typeof AppJournalRecordRoute
  '/app/onboarding/building-plan': typeof AppOnboardingBuildingPlanRoute
  '/app/onboarding/children': typeof AppOnboardingChildrenRoute
  '/app/onboarding/children-count': typeof AppOnboardingChildrenCountRoute
  '/app/onboarding/current-tools': typeof AppOnboardingCurrentToolsRoute
  '/app/onboarding/goals': typeof AppOnboardingGoalsRoute
  '/app/onboarding/invite': typeof AppOnboardingInviteRoute
  '/app/onboarding/pain-point': typeof AppOnboardingPainPointRoute
  '/app/onboarding/profile': typeof AppOnboardingProfileRoute
  '/app/onboarding/situation': typeof AppOnboardingSituationRoute
  '/app/onboarding/social-proof': typeof AppOnboardingSocialProofRoute
  '/app/onboarding/welcome': typeof AppOnboardingWelcomeRoute
  '/app/payments/$id': typeof AppPaymentsIdRoute
  '/app/payments/record': typeof AppPaymentsRecordRoute
  '/app/vault/$beneficiaryId': typeof AppVaultBeneficiaryIdRoute
  '/auth/pro/sign-in': typeof AuthProSignInRoute
  '/auth/pro/sign-up': typeof AuthProSignUpRoute
  '/pro/clients/$inviteId': typeof ProClientsInviteIdRouteWithChildren
  '/redeem/pro/$code': typeof RedeemProCodeRoute
  '/admin/drip-campaigns/': typeof AdminDripCampaignsIndexRoute
  '/admin/professionals/': typeof AdminProfessionalsIndexRoute
  '/app/calendar/': typeof AppCalendarIndexRoute
  '/app/expenses/': typeof AppExpensesIndexRoute
  '/app/journal/': typeof AppJournalIndexRoute
  '/admin/users/$userId/actions': typeof AdminUsersUserIdActionsRoute
  '/admin/users/$userId/audit': typeof AdminUsersUserIdAuditRoute
  '/admin/users/$userId/chat': typeof AdminUsersUserIdChatRoute
  '/admin/users/$userId/expenses': typeof AdminUsersUserIdExpensesRoute
  '/admin/users/$userId/exports': typeof AdminUsersUserIdExportsRoute
  '/admin/users/$userId/households': typeof AdminUsersUserIdHouseholdsRoute
  '/admin/users/$userId/journal': typeof AdminUsersUserIdJournalRoute
  '/admin/users/$userId/tools': typeof AdminUsersUserIdToolsRoute
  '/app/calendar/events/$eventId': typeof AppCalendarEventsEventIdRoute
  '/app/calendar/events/add': typeof AppCalendarEventsAddRoute
  '/app/chat/custom/$chatId': typeof AppChatCustomChatIdRoute
  '/app/chat/expense/$disputeId': typeof AppChatExpenseDisputeIdRoute
  '/app/chat/payment/$disputeId': typeof AppChatPaymentDisputeIdRoute
  '/pro/clients/$inviteId/calendar': typeof ProClientsInviteIdCalendarRoute
  '/pro/clients/$inviteId/chat': typeof ProClientsInviteIdChatRoute
  '/pro/clients/$inviteId/expenses': typeof ProClientsInviteIdExpensesRoute
  '/pro/clients/$inviteId/journal': typeof ProClientsInviteIdJournalRoute
  '/admin/users/$userId/': typeof AdminUsersUserIdIndexRoute
  '/pro/clients/$inviteId/': typeof ProClientsInviteIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/app'
    | '/coaches'
    | '/contact'
    | '/court-order-language'
    | '/features'
    | '/privacy-policy'
    | '/pro'
    | '/pro-callback'
    | '/support'
    | '/terms-of-service'
    | '/admin/ads'
    | '/admin/attribution'
    | '/admin/chats'
    | '/admin/coach-engagement'
    | '/admin/coach-outreach'
    | '/admin/directory-profiles'
    | '/admin/drip-campaigns'
    | '/admin/journal'
    | '/admin/metrics'
    | '/admin/performance'
    | '/admin/pro-invite-reminders'
    | '/admin/professional-codes'
    | '/admin/professionals'
    | '/admin/prospects'
    | '/admin/pulse'
    | '/admin/seo'
    | '/admin/tools'
    | '/admin/vault'
    | '/app/chat'
    | '/app/notifications'
    | '/app/settings'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/child-support-calculator/$state'
    | '/compare/$competitor'
    | '/learn/coparents'
    | '/learn/practitioners'
    | '/parenting-plan/$schedule'
    | '/parenting-plan/builder'
    | '/pro/directory'
    | '/purchase/cancel'
    | '/purchase/success'
    | '/admin/'
    | '/auth'
    | '/child-support-calculator'
    | '/compare'
    | '/parenting-plan'
    | '/pro/'
    | '/purchase'
    | '/admin/drip-campaigns/activation'
    | '/admin/drip-campaigns/conversion'
    | '/admin/drip-campaigns/growth'
    | '/admin/drip-campaigns/prospects'
    | '/admin/drip-campaigns/retention'
    | '/admin/professionals/codes'
    | '/admin/professionals/engagement'
    | '/admin/professionals/invites'
    | '/admin/users/$userId'
    | '/app/calendar/$scheduleId'
    | '/app/calendar/add-check-in'
    | '/app/calendar/add-exception'
    | '/app/calendar/add-schedule'
    | '/app/calendar/check-ins'
    | '/app/calendar/compliance'
    | '/app/calendar/log-exchange'
    | '/app/chat/main'
    | '/app/expenses/$id'
    | '/app/expenses/record'
    | '/app/journal/$entryId'
    | '/app/journal/record'
    | '/app/onboarding/building-plan'
    | '/app/onboarding/children'
    | '/app/onboarding/children-count'
    | '/app/onboarding/current-tools'
    | '/app/onboarding/goals'
    | '/app/onboarding/invite'
    | '/app/onboarding/pain-point'
    | '/app/onboarding/profile'
    | '/app/onboarding/situation'
    | '/app/onboarding/social-proof'
    | '/app/onboarding/welcome'
    | '/app/payments/$id'
    | '/app/payments/record'
    | '/app/vault/$beneficiaryId'
    | '/auth/pro/sign-in'
    | '/auth/pro/sign-up'
    | '/pro/clients/$inviteId'
    | '/redeem/pro/$code'
    | '/admin/drip-campaigns/'
    | '/admin/professionals/'
    | '/app/calendar'
    | '/app/expenses'
    | '/app/journal'
    | '/admin/users/$userId/actions'
    | '/admin/users/$userId/audit'
    | '/admin/users/$userId/chat'
    | '/admin/users/$userId/expenses'
    | '/admin/users/$userId/exports'
    | '/admin/users/$userId/households'
    | '/admin/users/$userId/journal'
    | '/admin/users/$userId/tools'
    | '/app/calendar/events/$eventId'
    | '/app/calendar/events/add'
    | '/app/chat/custom/$chatId'
    | '/app/chat/expense/$disputeId'
    | '/app/chat/payment/$disputeId'
    | '/pro/clients/$inviteId/calendar'
    | '/pro/clients/$inviteId/chat'
    | '/pro/clients/$inviteId/expenses'
    | '/pro/clients/$inviteId/journal'
    | '/admin/users/$userId/'
    | '/pro/clients/$inviteId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/app'
    | '/coaches'
    | '/contact'
    | '/court-order-language'
    | '/features'
    | '/privacy-policy'
    | '/pro-callback'
    | '/support'
    | '/terms-of-service'
    | '/admin/ads'
    | '/admin/attribution'
    | '/admin/chats'
    | '/admin/coach-engagement'
    | '/admin/coach-outreach'
    | '/admin/directory-profiles'
    | '/admin/journal'
    | '/admin/metrics'
    | '/admin/performance'
    | '/admin/pro-invite-reminders'
    | '/admin/professional-codes'
    | '/admin/prospects'
    | '/admin/pulse'
    | '/admin/seo'
    | '/admin/tools'
    | '/admin/vault'
    | '/app/chat'
    | '/app/notifications'
    | '/app/settings'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/child-support-calculator/$state'
    | '/compare/$competitor'
    | '/learn/coparents'
    | '/learn/practitioners'
    | '/parenting-plan/$schedule'
    | '/parenting-plan/builder'
    | '/pro/directory'
    | '/purchase/cancel'
    | '/purchase/success'
    | '/admin'
    | '/auth'
    | '/child-support-calculator'
    | '/compare'
    | '/parenting-plan'
    | '/pro'
    | '/purchase'
    | '/admin/drip-campaigns/activation'
    | '/admin/drip-campaigns/conversion'
    | '/admin/drip-campaigns/growth'
    | '/admin/drip-campaigns/prospects'
    | '/admin/drip-campaigns/retention'
    | '/admin/professionals/codes'
    | '/admin/professionals/engagement'
    | '/admin/professionals/invites'
    | '/app/calendar/$scheduleId'
    | '/app/calendar/add-check-in'
    | '/app/calendar/add-exception'
    | '/app/calendar/add-schedule'
    | '/app/calendar/check-ins'
    | '/app/calendar/compliance'
    | '/app/calendar/log-exchange'
    | '/app/chat/main'
    | '/app/expenses/$id'
    | '/app/expenses/record'
    | '/app/journal/$entryId'
    | '/app/journal/record'
    | '/app/onboarding/building-plan'
    | '/app/onboarding/children'
    | '/app/onboarding/children-count'
    | '/app/onboarding/current-tools'
    | '/app/onboarding/goals'
    | '/app/onboarding/invite'
    | '/app/onboarding/pain-point'
    | '/app/onboarding/profile'
    | '/app/onboarding/situation'
    | '/app/onboarding/social-proof'
    | '/app/onboarding/welcome'
    | '/app/payments/$id'
    | '/app/payments/record'
    | '/app/vault/$beneficiaryId'
    | '/auth/pro/sign-in'
    | '/auth/pro/sign-up'
    | '/redeem/pro/$code'
    | '/admin/drip-campaigns'
    | '/admin/professionals'
    | '/app/calendar'
    | '/app/expenses'
    | '/app/journal'
    | '/admin/users/$userId/actions'
    | '/admin/users/$userId/audit'
    | '/admin/users/$userId/chat'
    | '/admin/users/$userId/expenses'
    | '/admin/users/$userId/exports'
    | '/admin/users/$userId/households'
    | '/admin/users/$userId/journal'
    | '/admin/users/$userId/tools'
    | '/app/calendar/events/$eventId'
    | '/app/calendar/events/add'
    | '/app/chat/custom/$chatId'
    | '/app/chat/expense/$disputeId'
    | '/app/chat/payment/$disputeId'
    | '/pro/clients/$inviteId/calendar'
    | '/pro/clients/$inviteId/chat'
    | '/pro/clients/$inviteId/expenses'
    | '/pro/clients/$inviteId/journal'
    | '/admin/users/$userId'
    | '/pro/clients/$inviteId'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/app'
    | '/coaches'
    | '/contact'
    | '/court-order-language'
    | '/features'
    | '/privacy-policy'
    | '/pro'
    | '/pro-callback'
    | '/support'
    | '/terms-of-service'
    | '/admin/ads'
    | '/admin/attribution'
    | '/admin/chats'
    | '/admin/coach-engagement'
    | '/admin/coach-outreach'
    | '/admin/directory-profiles'
    | '/admin/drip-campaigns'
    | '/admin/journal'
    | '/admin/metrics'
    | '/admin/performance'
    | '/admin/pro-invite-reminders'
    | '/admin/professional-codes'
    | '/admin/professionals'
    | '/admin/prospects'
    | '/admin/pulse'
    | '/admin/seo'
    | '/admin/tools'
    | '/admin/vault'
    | '/app/chat'
    | '/app/notifications'
    | '/app/settings'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/child-support-calculator/$state'
    | '/compare/$competitor'
    | '/learn/coparents'
    | '/learn/practitioners'
    | '/parenting-plan/$schedule'
    | '/parenting-plan/builder'
    | '/pro/directory'
    | '/purchase/cancel'
    | '/purchase/success'
    | '/admin/'
    | '/auth/'
    | '/child-support-calculator/'
    | '/compare/'
    | '/parenting-plan/'
    | '/pro/'
    | '/purchase/'
    | '/admin/drip-campaigns/activation'
    | '/admin/drip-campaigns/conversion'
    | '/admin/drip-campaigns/growth'
    | '/admin/drip-campaigns/prospects'
    | '/admin/drip-campaigns/retention'
    | '/admin/professionals/codes'
    | '/admin/professionals/engagement'
    | '/admin/professionals/invites'
    | '/admin/users/$userId'
    | '/app/calendar/$scheduleId'
    | '/app/calendar/add-check-in'
    | '/app/calendar/add-exception'
    | '/app/calendar/add-schedule'
    | '/app/calendar/check-ins'
    | '/app/calendar/compliance'
    | '/app/calendar/log-exchange'
    | '/app/chat/main'
    | '/app/expenses/$id'
    | '/app/expenses/record'
    | '/app/journal/$entryId'
    | '/app/journal/record'
    | '/app/onboarding/building-plan'
    | '/app/onboarding/children'
    | '/app/onboarding/children-count'
    | '/app/onboarding/current-tools'
    | '/app/onboarding/goals'
    | '/app/onboarding/invite'
    | '/app/onboarding/pain-point'
    | '/app/onboarding/profile'
    | '/app/onboarding/situation'
    | '/app/onboarding/social-proof'
    | '/app/onboarding/welcome'
    | '/app/payments/$id'
    | '/app/payments/record'
    | '/app/vault/$beneficiaryId'
    | '/auth/pro/sign-in'
    | '/auth/pro/sign-up'
    | '/pro/clients/$inviteId'
    | '/redeem/pro/$code'
    | '/admin/drip-campaigns/'
    | '/admin/professionals/'
    | '/app/calendar/'
    | '/app/expenses/'
    | '/app/journal/'
    | '/admin/users/$userId/actions'
    | '/admin/users/$userId/audit'
    | '/admin/users/$userId/chat'
    | '/admin/users/$userId/expenses'
    | '/admin/users/$userId/exports'
    | '/admin/users/$userId/households'
    | '/admin/users/$userId/journal'
    | '/admin/users/$userId/tools'
    | '/app/calendar/events/$eventId'
    | '/app/calendar/events/add'
    | '/app/chat/custom/$chatId'
    | '/app/chat/expense/$disputeId'
    | '/app/chat/payment/$disputeId'
    | '/pro/clients/$inviteId/calendar'
    | '/pro/clients/$inviteId/chat'
    | '/pro/clients/$inviteId/expenses'
    | '/pro/clients/$inviteId/journal'
    | '/admin/users/$userId/'
    | '/pro/clients/$inviteId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  AppRoute: typeof AppRouteWithChildren
  CoachesRoute: typeof CoachesRoute
  ContactRoute: typeof ContactRoute
  CourtOrderLanguageRoute: typeof CourtOrderLanguageRoute
  FeaturesRoute: typeof FeaturesRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  ProRoute: typeof ProRouteWithChildren
  ProCallbackRoute: typeof ProCallbackRoute
  SupportRoute: typeof SupportRoute
  TermsOfServiceRoute: typeof TermsOfServiceRoute
  AuthSignInRoute: typeof AuthSignInRoute
  AuthSignUpRoute: typeof AuthSignUpRoute
  ChildSupportCalculatorStateRoute: typeof ChildSupportCalculatorStateRoute
  CompareCompetitorRoute: typeof CompareCompetitorRoute
  LearnCoparentsRoute: typeof LearnCoparentsRoute
  LearnPractitionersRoute: typeof LearnPractitionersRoute
  ParentingPlanScheduleRoute: typeof ParentingPlanScheduleRoute
  ParentingPlanBuilderRoute: typeof ParentingPlanBuilderRoute
  PurchaseCancelRoute: typeof PurchaseCancelRoute
  PurchaseSuccessRoute: typeof PurchaseSuccessRoute
  AuthIndexRoute: typeof AuthIndexRoute
  ChildSupportCalculatorIndexRoute: typeof ChildSupportCalculatorIndexRoute
  CompareIndexRoute: typeof CompareIndexRoute
  ParentingPlanIndexRoute: typeof ParentingPlanIndexRoute
  PurchaseIndexRoute: typeof PurchaseIndexRoute
  AuthProSignInRoute: typeof AuthProSignInRoute
  AuthProSignUpRoute: typeof AuthProSignUpRoute
  RedeemProCodeRoute: typeof RedeemProCodeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms-of-service': {
      id: '/terms-of-service'
      path: '/terms-of-service'
      fullPath: '/terms-of-service'
      preLoaderRoute: typeof TermsOfServiceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support': {
      id: '/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof SupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pro-callback': {
      id: '/pro-callback'
      path: '/pro-callback'
      fullPath: '/pro-callback'
      preLoaderRoute: typeof ProCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pro': {
      id: '/pro'
      path: '/pro'
      fullPath: '/pro'
      preLoaderRoute: typeof ProRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/features': {
      id: '/features'
      path: '/features'
      fullPath: '/features'
      preLoaderRoute: typeof FeaturesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/court-order-language': {
      id: '/court-order-language'
      path: '/court-order-language'
      fullPath: '/court-order-language'
      preLoaderRoute: typeof CourtOrderLanguageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/coaches': {
      id: '/coaches'
      path: '/coaches'
      fullPath: '/coaches'
      preLoaderRoute: typeof CoachesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/purchase/': {
      id: '/purchase/'
      path: '/purchase'
      fullPath: '/purchase'
      preLoaderRoute: typeof PurchaseIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pro/': {
      id: '/pro/'
      path: '/'
      fullPath: '/pro/'
      preLoaderRoute: typeof ProIndexRouteImport
      parentRoute: typeof ProRoute
    }
    '/parenting-plan/': {
      id: '/parenting-plan/'
      path: '/parenting-plan'
      fullPath: '/parenting-plan'
      preLoaderRoute: typeof ParentingPlanIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compare/': {
      id: '/compare/'
      path: '/compare'
      fullPath: '/compare'
      preLoaderRoute: typeof CompareIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/child-support-calculator/': {
      id: '/child-support-calculator/'
      path: '/child-support-calculator'
      fullPath: '/child-support-calculator'
      preLoaderRoute: typeof ChildSupportCalculatorIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/': {
      id: '/auth/'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/purchase/success': {
      id: '/purchase/success'
      path: '/purchase/success'
      fullPath: '/purchase/success'
      preLoaderRoute: typeof PurchaseSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/purchase/cancel': {
      id: '/purchase/cancel'
      path: '/purchase/cancel'
      fullPath: '/purchase/cancel'
      preLoaderRoute: typeof PurchaseCancelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pro/directory': {
      id: '/pro/directory'
      path: '/directory'
      fullPath: '/pro/directory'
      preLoaderRoute: typeof ProDirectoryRouteImport
      parentRoute: typeof ProRoute
    }
    '/parenting-plan/builder': {
      id: '/parenting-plan/builder'
      path: '/parenting-plan/builder'
      fullPath: '/parenting-plan/builder'
      preLoaderRoute: typeof ParentingPlanBuilderRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/parenting-plan/$schedule': {
      id: '/parenting-plan/$schedule'
      path: '/parenting-plan/$schedule'
      fullPath: '/parenting-plan/$schedule'
      preLoaderRoute: typeof ParentingPlanScheduleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/learn/practitioners': {
      id: '/learn/practitioners'
      path: '/learn/practitioners'
      fullPath: '/learn/practitioners'
      preLoaderRoute: typeof LearnPractitionersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/learn/coparents': {
      id: '/learn/coparents'
      path: '/learn/coparents'
      fullPath: '/learn/coparents'
      preLoaderRoute: typeof LearnCoparentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compare/$competitor': {
      id: '/compare/$competitor'
      path: '/compare/$competitor'
      fullPath: '/compare/$competitor'
      preLoaderRoute: typeof CompareCompetitorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/child-support-calculator/$state': {
      id: '/child-support-calculator/$state'
      path: '/child-support-calculator/$state'
      fullPath: '/child-support-calculator/$state'
      preLoaderRoute: typeof ChildSupportCalculatorStateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/sign-up': {
      id: '/auth/sign-up'
      path: '/auth/sign-up'
      fullPath: '/auth/sign-up'
      preLoaderRoute: typeof AuthSignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/sign-in': {
      id: '/auth/sign-in'
      path: '/auth/sign-in'
      fullPath: '/auth/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/settings': {
      id: '/app/settings'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/notifications': {
      id: '/app/notifications'
      path: '/notifications'
      fullPath: '/app/notifications'
      preLoaderRoute: typeof AppNotificationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/chat': {
      id: '/app/chat'
      path: '/chat'
      fullPath: '/app/chat'
      preLoaderRoute: typeof AppChatRouteImport
      parentRoute: typeof AppRoute
    }
    '/admin/vault': {
      id: '/admin/vault'
      path: '/vault'
      fullPath: '/admin/vault'
      preLoaderRoute: typeof AdminVaultRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/tools': {
      id: '/admin/tools'
      path: '/tools'
      fullPath: '/admin/tools'
      preLoaderRoute: typeof AdminToolsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/seo': {
      id: '/admin/seo'
      path: '/seo'
      fullPath: '/admin/seo'
      preLoaderRoute: typeof AdminSeoRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/pulse': {
      id: '/admin/pulse'
      path: '/pulse'
      fullPath: '/admin/pulse'
      preLoaderRoute: typeof AdminPulseRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/prospects': {
      id: '/admin/prospects'
      path: '/prospects'
      fullPath: '/admin/prospects'
      preLoaderRoute: typeof AdminProspectsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/professionals': {
      id: '/admin/professionals'
      path: '/professionals'
      fullPath: '/admin/professionals'
      preLoaderRoute: typeof AdminProfessionalsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/professional-codes': {
      id: '/admin/professional-codes'
      path: '/professional-codes'
      fullPath: '/admin/professional-codes'
      preLoaderRoute: typeof AdminProfessionalCodesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/pro-invite-reminders': {
      id: '/admin/pro-invite-reminders'
      path: '/pro-invite-reminders'
      fullPath: '/admin/pro-invite-reminders'
      preLoaderRoute: typeof AdminProInviteRemindersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/performance': {
      id: '/admin/performance'
      path: '/performance'
      fullPath: '/admin/performance'
      preLoaderRoute: typeof AdminPerformanceRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/metrics': {
      id: '/admin/metrics'
      path: '/metrics'
      fullPath: '/admin/metrics'
      preLoaderRoute: typeof AdminMetricsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/journal': {
      id: '/admin/journal'
      path: '/journal'
      fullPath: '/admin/journal'
      preLoaderRoute: typeof AdminJournalRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/drip-campaigns': {
      id: '/admin/drip-campaigns'
      path: '/drip-campaigns'
      fullPath: '/admin/drip-campaigns'
      preLoaderRoute: typeof AdminDripCampaignsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/directory-profiles': {
      id: '/admin/directory-profiles'
      path: '/directory-profiles'
      fullPath: '/admin/directory-profiles'
      preLoaderRoute: typeof AdminDirectoryProfilesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/coach-outreach': {
      id: '/admin/coach-outreach'
      path: '/coach-outreach'
      fullPath: '/admin/coach-outreach'
      preLoaderRoute: typeof AdminCoachOutreachRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/coach-engagement': {
      id: '/admin/coach-engagement'
      path: '/coach-engagement'
      fullPath: '/admin/coach-engagement'
      preLoaderRoute: typeof AdminCoachEngagementRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/chats': {
      id: '/admin/chats'
      path: '/chats'
      fullPath: '/admin/chats'
      preLoaderRoute: typeof AdminChatsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/attribution': {
      id: '/admin/attribution'
      path: '/attribution'
      fullPath: '/admin/attribution'
      preLoaderRoute: typeof AdminAttributionRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/ads': {
      id: '/admin/ads'
      path: '/ads'
      fullPath: '/admin/ads'
      preLoaderRoute: typeof AdminAdsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/app/journal/': {
      id: '/app/journal/'
      path: '/journal'
      fullPath: '/app/journal'
      preLoaderRoute: typeof AppJournalIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/expenses/': {
      id: '/app/expenses/'
      path: '/expenses'
      fullPath: '/app/expenses'
      preLoaderRoute: typeof AppExpensesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/calendar/': {
      id: '/app/calendar/'
      path: '/calendar'
      fullPath: '/app/calendar'
      preLoaderRoute: typeof AppCalendarIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/admin/professionals/': {
      id: '/admin/professionals/'
      path: '/'
      fullPath: '/admin/professionals/'
      preLoaderRoute: typeof AdminProfessionalsIndexRouteImport
      parentRoute: typeof AdminProfessionalsRoute
    }
    '/admin/drip-campaigns/': {
      id: '/admin/drip-campaigns/'
      path: '/'
      fullPath: '/admin/drip-campaigns/'
      preLoaderRoute: typeof AdminDripCampaignsIndexRouteImport
      parentRoute: typeof AdminDripCampaignsRoute
    }
    '/redeem/pro/$code': {
      id: '/redeem/pro/$code'
      path: '/redeem/pro/$code'
      fullPath: '/redeem/pro/$code'
      preLoaderRoute: typeof RedeemProCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pro/clients/$inviteId': {
      id: '/pro/clients/$inviteId'
      path: '/clients/$inviteId'
      fullPath: '/pro/clients/$inviteId'
      preLoaderRoute: typeof ProClientsInviteIdRouteImport
      parentRoute: typeof ProRoute
    }
    '/auth/pro/sign-up': {
      id: '/auth/pro/sign-up'
      path: '/auth/pro/sign-up'
      fullPath: '/auth/pro/sign-up'
      preLoaderRoute: typeof AuthProSignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/pro/sign-in': {
      id: '/auth/pro/sign-in'
      path: '/auth/pro/sign-in'
      fullPath: '/auth/pro/sign-in'
      preLoaderRoute: typeof AuthProSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/vault/$beneficiaryId': {
      id: '/app/vault/$beneficiaryId'
      path: '/vault/$beneficiaryId'
      fullPath: '/app/vault/$beneficiaryId'
      preLoaderRoute: typeof AppVaultBeneficiaryIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/payments/record': {
      id: '/app/payments/record'
      path: '/payments/record'
      fullPath: '/app/payments/record'
      preLoaderRoute: typeof AppPaymentsRecordRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/payments/$id': {
      id: '/app/payments/$id'
      path: '/payments/$id'
      fullPath: '/app/payments/$id'
      preLoaderRoute: typeof AppPaymentsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/onboarding/welcome': {
      id: '/app/onboarding/welcome'
      path: '/onboarding/welcome'
      fullPath: '/app/onboarding/welcome'
      preLoaderRoute: typeof AppOnboardingWelcomeRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/onboarding/social-proof': {
      id: '/app/onboarding/social-proof'
      path: '/onboarding/social-proof'
      fullPath: '/app/onboarding/social-proof'
      preLoaderRoute: typeof AppOnboardingSocialProofRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/onboarding/situation': {
      id: '/app/onboarding/situation'
      path: '/onboarding/situation'
      fullPath: '/app/onboarding/situation'
      preLoaderRoute: typeof AppOnboardingSituationRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/onboarding/profile': {
      id: '/app/onboarding/profile'
      path: '/onboarding/profile'
      fullPath: '/app/onboarding/profile'
      preLoaderRoute: typeof AppOnboardingProfileRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/onboarding/pain-point': {
      id: '/app/onboarding/pain-point'
      path: '/onboarding/pain-point'
      fullPath: '/app/onboarding/pain-point'
      preLoaderRoute: typeof AppOnboardingPainPointRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/onboarding/invite': {
      id: '/app/onboarding/invite'
      path: '/onboarding/invite'
      fullPath: '/app/onboarding/invite'
      preLoaderRoute: typeof AppOnboardingInviteRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/onboarding/goals': {
      id: '/app/onboarding/goals'
      path: '/onboarding/goals'
      fullPath: '/app/onboarding/goals'
      preLoaderRoute: typeof AppOnboardingGoalsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/onboarding/current-tools': {
      id: '/app/onboarding/current-tools'
      path: '/onboarding/current-tools'
      fullPath: '/app/onboarding/current-tools'
      preLoaderRoute: typeof AppOnboardingCurrentToolsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/onboarding/children-count': {
      id: '/app/onboarding/children-count'
      path: '/onboarding/children-count'
      fullPath: '/app/onboarding/children-count'
      preLoaderRoute: typeof AppOnboardingChildrenCountRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/onboarding/children': {
      id: '/app/onboarding/children'
      path: '/onboarding/children'
      fullPath: '/app/onboarding/children'
      preLoaderRoute: typeof AppOnboardingChildrenRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/onboarding/building-plan': {
      id: '/app/onboarding/building-plan'
      path: '/onboarding/building-plan'
      fullPath: '/app/onboarding/building-plan'
      preLoaderRoute: typeof AppOnboardingBuildingPlanRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/journal/record': {
      id: '/app/journal/record'
      path: '/journal/record'
      fullPath: '/app/journal/record'
      preLoaderRoute: typeof AppJournalRecordRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/journal/$entryId': {
      id: '/app/journal/$entryId'
      path: '/journal/$entryId'
      fullPath: '/app/journal/$entryId'
      preLoaderRoute: typeof AppJournalEntryIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/expenses/record': {
      id: '/app/expenses/record'
      path: '/expenses/record'
      fullPath: '/app/expenses/record'
      preLoaderRoute: typeof AppExpensesRecordRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/expenses/$id': {
      id: '/app/expenses/$id'
      path: '/expenses/$id'
      fullPath: '/app/expenses/$id'
      preLoaderRoute: typeof AppExpensesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/chat/main': {
      id: '/app/chat/main'
      path: '/main'
      fullPath: '/app/chat/main'
      preLoaderRoute: typeof AppChatMainRouteImport
      parentRoute: typeof AppChatRoute
    }
    '/app/calendar/log-exchange': {
      id: '/app/calendar/log-exchange'
      path: '/calendar/log-exchange'
      fullPath: '/app/calendar/log-exchange'
      preLoaderRoute: typeof AppCalendarLogExchangeRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/calendar/compliance': {
      id: '/app/calendar/compliance'
      path: '/calendar/compliance'
      fullPath: '/app/calendar/compliance'
      preLoaderRoute: typeof AppCalendarComplianceRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/calendar/check-ins': {
      id: '/app/calendar/check-ins'
      path: '/calendar/check-ins'
      fullPath: '/app/calendar/check-ins'
      preLoaderRoute: typeof AppCalendarCheckInsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/calendar/add-schedule': {
      id: '/app/calendar/add-schedule'
      path: '/calendar/add-schedule'
      fullPath: '/app/calendar/add-schedule'
      preLoaderRoute: typeof AppCalendarAddScheduleRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/calendar/add-exception': {
      id: '/app/calendar/add-exception'
      path: '/calendar/add-exception'
      fullPath: '/app/calendar/add-exception'
      preLoaderRoute: typeof AppCalendarAddExceptionRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/calendar/add-check-in': {
      id: '/app/calendar/add-check-in'
      path: '/calendar/add-check-in'
      fullPath: '/app/calendar/add-check-in'
      preLoaderRoute: typeof AppCalendarAddCheckInRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/calendar/$scheduleId': {
      id: '/app/calendar/$scheduleId'
      path: '/calendar/$scheduleId'
      fullPath: '/app/calendar/$scheduleId'
      preLoaderRoute: typeof AppCalendarScheduleIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/admin/users/$userId': {
      id: '/admin/users/$userId'
      path: '/users/$userId'
      fullPath: '/admin/users/$userId'
      preLoaderRoute: typeof AdminUsersUserIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/professionals/invites': {
      id: '/admin/professionals/invites'
      path: '/invites'
      fullPath: '/admin/professionals/invites'
      preLoaderRoute: typeof AdminProfessionalsInvitesRouteImport
      parentRoute: typeof AdminProfessionalsRoute
    }
    '/admin/professionals/engagement': {
      id: '/admin/professionals/engagement'
      path: '/engagement'
      fullPath: '/admin/professionals/engagement'
      preLoaderRoute: typeof AdminProfessionalsEngagementRouteImport
      parentRoute: typeof AdminProfessionalsRoute
    }
    '/admin/professionals/codes': {
      id: '/admin/professionals/codes'
      path: '/codes'
      fullPath: '/admin/professionals/codes'
      preLoaderRoute: typeof AdminProfessionalsCodesRouteImport
      parentRoute: typeof AdminProfessionalsRoute
    }
    '/admin/drip-campaigns/retention': {
      id: '/admin/drip-campaigns/retention'
      path: '/retention'
      fullPath: '/admin/drip-campaigns/retention'
      preLoaderRoute: typeof AdminDripCampaignsRetentionRouteImport
      parentRoute: typeof AdminDripCampaignsRoute
    }
    '/admin/drip-campaigns/prospects': {
      id: '/admin/drip-campaigns/prospects'
      path: '/prospects'
      fullPath: '/admin/drip-campaigns/prospects'
      preLoaderRoute: typeof AdminDripCampaignsProspectsRouteImport
      parentRoute: typeof AdminDripCampaignsRoute
    }
    '/admin/drip-campaigns/growth': {
      id: '/admin/drip-campaigns/growth'
      path: '/growth'
      fullPath: '/admin/drip-campaigns/growth'
      preLoaderRoute: typeof AdminDripCampaignsGrowthRouteImport
      parentRoute: typeof AdminDripCampaignsRoute
    }
    '/admin/drip-campaigns/conversion': {
      id: '/admin/drip-campaigns/conversion'
      path: '/conversion'
      fullPath: '/admin/drip-campaigns/conversion'
      preLoaderRoute: typeof AdminDripCampaignsConversionRouteImport
      parentRoute: typeof AdminDripCampaignsRoute
    }
    '/admin/drip-campaigns/activation': {
      id: '/admin/drip-campaigns/activation'
      path: '/activation'
      fullPath: '/admin/drip-campaigns/activation'
      preLoaderRoute: typeof AdminDripCampaignsActivationRouteImport
      parentRoute: typeof AdminDripCampaignsRoute
    }
    '/pro/clients/$inviteId/': {
      id: '/pro/clients/$inviteId/'
      path: '/'
      fullPath: '/pro/clients/$inviteId/'
      preLoaderRoute: typeof ProClientsInviteIdIndexRouteImport
      parentRoute: typeof ProClientsInviteIdRoute
    }
    '/admin/users/$userId/': {
      id: '/admin/users/$userId/'
      path: '/'
      fullPath: '/admin/users/$userId/'
      preLoaderRoute: typeof AdminUsersUserIdIndexRouteImport
      parentRoute: typeof AdminUsersUserIdRoute
    }
    '/pro/clients/$inviteId/journal': {
      id: '/pro/clients/$inviteId/journal'
      path: '/journal'
      fullPath: '/pro/clients/$inviteId/journal'
      preLoaderRoute: typeof ProClientsInviteIdJournalRouteImport
      parentRoute: typeof ProClientsInviteIdRoute
    }
    '/pro/clients/$inviteId/expenses': {
      id: '/pro/clients/$inviteId/expenses'
      path: '/expenses'
      fullPath: '/pro/clients/$inviteId/expenses'
      preLoaderRoute: typeof ProClientsInviteIdExpensesRouteImport
      parentRoute: typeof ProClientsInviteIdRoute
    }
    '/pro/clients/$inviteId/chat': {
      id: '/pro/clients/$inviteId/chat'
      path: '/chat'
      fullPath: '/pro/clients/$inviteId/chat'
      preLoaderRoute: typeof ProClientsInviteIdChatRouteImport
      parentRoute: typeof ProClientsInviteIdRoute
    }
    '/pro/clients/$inviteId/calendar': {
      id: '/pro/clients/$inviteId/calendar'
      path: '/calendar'
      fullPath: '/pro/clients/$inviteId/calendar'
      preLoaderRoute: typeof ProClientsInviteIdCalendarRouteImport
      parentRoute: typeof ProClientsInviteIdRoute
    }
    '/app/chat/payment/$disputeId': {
      id: '/app/chat/payment/$disputeId'
      path: '/payment/$disputeId'
      fullPath: '/app/chat/payment/$disputeId'
      preLoaderRoute: typeof AppChatPaymentDisputeIdRouteImport
      parentRoute: typeof AppChatRoute
    }
    '/app/chat/expense/$disputeId': {
      id: '/app/chat/expense/$disputeId'
      path: '/expense/$disputeId'
      fullPath: '/app/chat/expense/$disputeId'
      preLoaderRoute: typeof AppChatExpenseDisputeIdRouteImport
      parentRoute: typeof AppChatRoute
    }
    '/app/chat/custom/$chatId': {
      id: '/app/chat/custom/$chatId'
      path: '/custom/$chatId'
      fullPath: '/app/chat/custom/$chatId'
      preLoaderRoute: typeof AppChatCustomChatIdRouteImport
      parentRoute: typeof AppChatRoute
    }
    '/app/calendar/events/add': {
      id: '/app/calendar/events/add'
      path: '/calendar/events/add'
      fullPath: '/app/calendar/events/add'
      preLoaderRoute: typeof AppCalendarEventsAddRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/calendar/events/$eventId': {
      id: '/app/calendar/events/$eventId'
      path: '/calendar/events/$eventId'
      fullPath: '/app/calendar/events/$eventId'
      preLoaderRoute: typeof AppCalendarEventsEventIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/admin/users/$userId/tools': {
      id: '/admin/users/$userId/tools'
      path: '/tools'
      fullPath: '/admin/users/$userId/tools'
      preLoaderRoute: typeof AdminUsersUserIdToolsRouteImport
      parentRoute: typeof AdminUsersUserIdRoute
    }
    '/admin/users/$userId/journal': {
      id: '/admin/users/$userId/journal'
      path: '/journal'
      fullPath: '/admin/users/$userId/journal'
      preLoaderRoute: typeof AdminUsersUserIdJournalRouteImport
      parentRoute: typeof AdminUsersUserIdRoute
    }
    '/admin/users/$userId/households': {
      id: '/admin/users/$userId/households'
      path: '/households'
      fullPath: '/admin/users/$userId/households'
      preLoaderRoute: typeof AdminUsersUserIdHouseholdsRouteImport
      parentRoute: typeof AdminUsersUserIdRoute
    }
    '/admin/users/$userId/exports': {
      id: '/admin/users/$userId/exports'
      path: '/exports'
      fullPath: '/admin/users/$userId/exports'
      preLoaderRoute: typeof AdminUsersUserIdExportsRouteImport
      parentRoute: typeof AdminUsersUserIdRoute
    }
    '/admin/users/$userId/expenses': {
      id: '/admin/users/$userId/expenses'
      path: '/expenses'
      fullPath: '/admin/users/$userId/expenses'
      preLoaderRoute: typeof AdminUsersUserIdExpensesRouteImport
      parentRoute: typeof AdminUsersUserIdRoute
    }
    '/admin/users/$userId/chat': {
      id: '/admin/users/$userId/chat'
      path: '/chat'
      fullPath: '/admin/users/$userId/chat'
      preLoaderRoute: typeof AdminUsersUserIdChatRouteImport
      parentRoute: typeof AdminUsersUserIdRoute
    }
    '/admin/users/$userId/audit': {
      id: '/admin/users/$userId/audit'
      path: '/audit'
      fullPath: '/admin/users/$userId/audit'
      preLoaderRoute: typeof AdminUsersUserIdAuditRouteImport
      parentRoute: typeof AdminUsersUserIdRoute
    }
    '/admin/users/$userId/actions': {
      id: '/admin/users/$userId/actions'
      path: '/actions'
      fullPath: '/admin/users/$userId/actions'
      preLoaderRoute: typeof AdminUsersUserIdActionsRouteImport
      parentRoute: typeof AdminUsersUserIdRoute
    }
  }
}

interface AdminDripCampaignsRouteChildren {
  AdminDripCampaignsActivationRoute: typeof AdminDripCampaignsActivationRoute
  AdminDripCampaignsConversionRoute: typeof AdminDripCampaignsConversionRoute
  AdminDripCampaignsGrowthRoute: typeof AdminDripCampaignsGrowthRoute
  AdminDripCampaignsProspectsRoute: typeof AdminDripCampaignsProspectsRoute
  AdminDripCampaignsRetentionRoute: typeof AdminDripCampaignsRetentionRoute
  AdminDripCampaignsIndexRoute: typeof AdminDripCampaignsIndexRoute
}

const AdminDripCampaignsRouteChildren: AdminDripCampaignsRouteChildren = {
  AdminDripCampaignsActivationRoute: AdminDripCampaignsActivationRoute,
  AdminDripCampaignsConversionRoute: AdminDripCampaignsConversionRoute,
  AdminDripCampaignsGrowthRoute: AdminDripCampaignsGrowthRoute,
  AdminDripCampaignsProspectsRoute: AdminDripCampaignsProspectsRoute,
  AdminDripCampaignsRetentionRoute: AdminDripCampaignsRetentionRoute,
  AdminDripCampaignsIndexRoute: AdminDripCampaignsIndexRoute,
}

const AdminDripCampaignsRouteWithChildren =
  AdminDripCampaignsRoute._addFileChildren(AdminDripCampaignsRouteChildren)

interface AdminProfessionalsRouteChildren {
  AdminProfessionalsCodesRoute: typeof AdminProfessionalsCodesRoute
  AdminProfessionalsEngagementRoute: typeof AdminProfessionalsEngagementRoute
  AdminProfessionalsInvitesRoute: typeof AdminProfessionalsInvitesRoute
  AdminProfessionalsIndexRoute: typeof AdminProfessionalsIndexRoute
}

const AdminProfessionalsRouteChildren: AdminProfessionalsRouteChildren = {
  AdminProfessionalsCodesRoute: AdminProfessionalsCodesRoute,
  AdminProfessionalsEngagementRoute: AdminProfessionalsEngagementRoute,
  AdminProfessionalsInvitesRoute: AdminProfessionalsInvitesRoute,
  AdminProfessionalsIndexRoute: AdminProfessionalsIndexRoute,
}

const AdminProfessionalsRouteWithChildren =
  AdminProfessionalsRoute._addFileChildren(AdminProfessionalsRouteChildren)

interface AdminUsersUserIdRouteChildren {
  AdminUsersUserIdActionsRoute: typeof AdminUsersUserIdActionsRoute
  AdminUsersUserIdAuditRoute: typeof AdminUsersUserIdAuditRoute
  AdminUsersUserIdChatRoute: typeof AdminUsersUserIdChatRoute
  AdminUsersUserIdExpensesRoute: typeof AdminUsersUserIdExpensesRoute
  AdminUsersUserIdExportsRoute: typeof AdminUsersUserIdExportsRoute
  AdminUsersUserIdHouseholdsRoute: typeof AdminUsersUserIdHouseholdsRoute
  AdminUsersUserIdJournalRoute: typeof AdminUsersUserIdJournalRoute
  AdminUsersUserIdToolsRoute: typeof AdminUsersUserIdToolsRoute
  AdminUsersUserIdIndexRoute: typeof AdminUsersUserIdIndexRoute
}

const AdminUsersUserIdRouteChildren: AdminUsersUserIdRouteChildren = {
  AdminUsersUserIdActionsRoute: AdminUsersUserIdActionsRoute,
  AdminUsersUserIdAuditRoute: AdminUsersUserIdAuditRoute,
  AdminUsersUserIdChatRoute: AdminUsersUserIdChatRoute,
  AdminUsersUserIdExpensesRoute: AdminUsersUserIdExpensesRoute,
  AdminUsersUserIdExportsRoute: AdminUsersUserIdExportsRoute,
  AdminUsersUserIdHouseholdsRoute: AdminUsersUserIdHouseholdsRoute,
  AdminUsersUserIdJournalRoute: AdminUsersUserIdJournalRoute,
  AdminUsersUserIdToolsRoute: AdminUsersUserIdToolsRoute,
  AdminUsersUserIdIndexRoute: AdminUsersUserIdIndexRoute,
}

const AdminUsersUserIdRouteWithChildren =
  AdminUsersUserIdRoute._addFileChildren(AdminUsersUserIdRouteChildren)

interface AdminRouteChildren {
  AdminAdsRoute: typeof AdminAdsRoute
  AdminAttributionRoute: typeof AdminAttributionRoute
  AdminChatsRoute: typeof AdminChatsRoute
  AdminCoachEngagementRoute: typeof AdminCoachEngagementRoute
  AdminCoachOutreachRoute: typeof AdminCoachOutreachRoute
  AdminDirectoryProfilesRoute: typeof AdminDirectoryProfilesRoute
  AdminDripCampaignsRoute: typeof AdminDripCampaignsRouteWithChildren
  AdminJournalRoute: typeof AdminJournalRoute
  AdminMetricsRoute: typeof AdminMetricsRoute
  AdminPerformanceRoute: typeof AdminPerformanceRoute
  AdminProInviteRemindersRoute: typeof AdminProInviteRemindersRoute
  AdminProfessionalCodesRoute: typeof AdminProfessionalCodesRoute
  AdminProfessionalsRoute: typeof AdminProfessionalsRouteWithChildren
  AdminProspectsRoute: typeof AdminProspectsRoute
  AdminPulseRoute: typeof AdminPulseRoute
  AdminSeoRoute: typeof AdminSeoRoute
  AdminToolsRoute: typeof AdminToolsRoute
  AdminVaultRoute: typeof AdminVaultRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminUsersUserIdRoute: typeof AdminUsersUserIdRouteWithChildren
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAdsRoute: AdminAdsRoute,
  AdminAttributionRoute: AdminAttributionRoute,
  AdminChatsRoute: AdminChatsRoute,
  AdminCoachEngagementRoute: AdminCoachEngagementRoute,
  AdminCoachOutreachRoute: AdminCoachOutreachRoute,
  AdminDirectoryProfilesRoute: AdminDirectoryProfilesRoute,
  AdminDripCampaignsRoute: AdminDripCampaignsRouteWithChildren,
  AdminJournalRoute: AdminJournalRoute,
  AdminMetricsRoute: AdminMetricsRoute,
  AdminPerformanceRoute: AdminPerformanceRoute,
  AdminProInviteRemindersRoute: AdminProInviteRemindersRoute,
  AdminProfessionalCodesRoute: AdminProfessionalCodesRoute,
  AdminProfessionalsRoute: AdminProfessionalsRouteWithChildren,
  AdminProspectsRoute: AdminProspectsRoute,
  AdminPulseRoute: AdminPulseRoute,
  AdminSeoRoute: AdminSeoRoute,
  AdminToolsRoute: AdminToolsRoute,
  AdminVaultRoute: AdminVaultRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminUsersUserIdRoute: AdminUsersUserIdRouteWithChildren,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface AppChatRouteChildren {
  AppChatMainRoute: typeof AppChatMainRoute
  AppChatCustomChatIdRoute: typeof AppChatCustomChatIdRoute
  AppChatExpenseDisputeIdRoute: typeof AppChatExpenseDisputeIdRoute
  AppChatPaymentDisputeIdRoute: typeof AppChatPaymentDisputeIdRoute
}

const AppChatRouteChildren: AppChatRouteChildren = {
  AppChatMainRoute: AppChatMainRoute,
  AppChatCustomChatIdRoute: AppChatCustomChatIdRoute,
  AppChatExpenseDisputeIdRoute: AppChatExpenseDisputeIdRoute,
  AppChatPaymentDisputeIdRoute: AppChatPaymentDisputeIdRoute,
}

const AppChatRouteWithChildren =
  AppChatRoute._addFileChildren(AppChatRouteChildren)

interface AppRouteChildren {
  AppChatRoute: typeof AppChatRouteWithChildren
  AppNotificationsRoute: typeof AppNotificationsRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppCalendarScheduleIdRoute: typeof AppCalendarScheduleIdRoute
  AppCalendarAddCheckInRoute: typeof AppCalendarAddCheckInRoute
  AppCalendarAddExceptionRoute: typeof AppCalendarAddExceptionRoute
  AppCalendarAddScheduleRoute: typeof AppCalendarAddScheduleRoute
  AppCalendarCheckInsRoute: typeof AppCalendarCheckInsRoute
  AppCalendarComplianceRoute: typeof AppCalendarComplianceRoute
  AppCalendarLogExchangeRoute: typeof AppCalendarLogExchangeRoute
  AppExpensesIdRoute: typeof AppExpensesIdRoute
  AppExpensesRecordRoute: typeof AppExpensesRecordRoute
  AppJournalEntryIdRoute: typeof AppJournalEntryIdRoute
  AppJournalRecordRoute: typeof AppJournalRecordRoute
  AppOnboardingBuildingPlanRoute: typeof AppOnboardingBuildingPlanRoute
  AppOnboardingChildrenRoute: typeof AppOnboardingChildrenRoute
  AppOnboardingChildrenCountRoute: typeof AppOnboardingChildrenCountRoute
  AppOnboardingCurrentToolsRoute: typeof AppOnboardingCurrentToolsRoute
  AppOnboardingGoalsRoute: typeof AppOnboardingGoalsRoute
  AppOnboardingInviteRoute: typeof AppOnboardingInviteRoute
  AppOnboardingPainPointRoute: typeof AppOnboardingPainPointRoute
  AppOnboardingProfileRoute: typeof AppOnboardingProfileRoute
  AppOnboardingSituationRoute: typeof AppOnboardingSituationRoute
  AppOnboardingSocialProofRoute: typeof AppOnboardingSocialProofRoute
  AppOnboardingWelcomeRoute: typeof AppOnboardingWelcomeRoute
  AppPaymentsIdRoute: typeof AppPaymentsIdRoute
  AppPaymentsRecordRoute: typeof AppPaymentsRecordRoute
  AppVaultBeneficiaryIdRoute: typeof AppVaultBeneficiaryIdRoute
  AppCalendarIndexRoute: typeof AppCalendarIndexRoute
  AppExpensesIndexRoute: typeof AppExpensesIndexRoute
  AppJournalIndexRoute: typeof AppJournalIndexRoute
  AppCalendarEventsEventIdRoute: typeof AppCalendarEventsEventIdRoute
  AppCalendarEventsAddRoute: typeof AppCalendarEventsAddRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppChatRoute: AppChatRouteWithChildren,
  AppNotificationsRoute: AppNotificationsRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppCalendarScheduleIdRoute: AppCalendarScheduleIdRoute,
  AppCalendarAddCheckInRoute: AppCalendarAddCheckInRoute,
  AppCalendarAddExceptionRoute: AppCalendarAddExceptionRoute,
  AppCalendarAddScheduleRoute: AppCalendarAddScheduleRoute,
  AppCalendarCheckInsRoute: AppCalendarCheckInsRoute,
  AppCalendarComplianceRoute: AppCalendarComplianceRoute,
  AppCalendarLogExchangeRoute: AppCalendarLogExchangeRoute,
  AppExpensesIdRoute: AppExpensesIdRoute,
  AppExpensesRecordRoute: AppExpensesRecordRoute,
  AppJournalEntryIdRoute: AppJournalEntryIdRoute,
  AppJournalRecordRoute: AppJournalRecordRoute,
  AppOnboardingBuildingPlanRoute: AppOnboardingBuildingPlanRoute,
  AppOnboardingChildrenRoute: AppOnboardingChildrenRoute,
  AppOnboardingChildrenCountRoute: AppOnboardingChildrenCountRoute,
  AppOnboardingCurrentToolsRoute: AppOnboardingCurrentToolsRoute,
  AppOnboardingGoalsRoute: AppOnboardingGoalsRoute,
  AppOnboardingInviteRoute: AppOnboardingInviteRoute,
  AppOnboardingPainPointRoute: AppOnboardingPainPointRoute,
  AppOnboardingProfileRoute: AppOnboardingProfileRoute,
  AppOnboardingSituationRoute: AppOnboardingSituationRoute,
  AppOnboardingSocialProofRoute: AppOnboardingSocialProofRoute,
  AppOnboardingWelcomeRoute: AppOnboardingWelcomeRoute,
  AppPaymentsIdRoute: AppPaymentsIdRoute,
  AppPaymentsRecordRoute: AppPaymentsRecordRoute,
  AppVaultBeneficiaryIdRoute: AppVaultBeneficiaryIdRoute,
  AppCalendarIndexRoute: AppCalendarIndexRoute,
  AppExpensesIndexRoute: AppExpensesIndexRoute,
  AppJournalIndexRoute: AppJournalIndexRoute,
  AppCalendarEventsEventIdRoute: AppCalendarEventsEventIdRoute,
  AppCalendarEventsAddRoute: AppCalendarEventsAddRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface ProClientsInviteIdRouteChildren {
  ProClientsInviteIdCalendarRoute: typeof ProClientsInviteIdCalendarRoute
  ProClientsInviteIdChatRoute: typeof ProClientsInviteIdChatRoute
  ProClientsInviteIdExpensesRoute: typeof ProClientsInviteIdExpensesRoute
  ProClientsInviteIdJournalRoute: typeof ProClientsInviteIdJournalRoute
  ProClientsInviteIdIndexRoute: typeof ProClientsInviteIdIndexRoute
}

const ProClientsInviteIdRouteChildren: ProClientsInviteIdRouteChildren = {
  ProClientsInviteIdCalendarRoute: ProClientsInviteIdCalendarRoute,
  ProClientsInviteIdChatRoute: ProClientsInviteIdChatRoute,
  ProClientsInviteIdExpensesRoute: ProClientsInviteIdExpensesRoute,
  ProClientsInviteIdJournalRoute: ProClientsInviteIdJournalRoute,
  ProClientsInviteIdIndexRoute: ProClientsInviteIdIndexRoute,
}

const ProClientsInviteIdRouteWithChildren =
  ProClientsInviteIdRoute._addFileChildren(ProClientsInviteIdRouteChildren)

interface ProRouteChildren {
  ProDirectoryRoute: typeof ProDirectoryRoute
  ProIndexRoute: typeof ProIndexRoute
  ProClientsInviteIdRoute: typeof ProClientsInviteIdRouteWithChildren
}

const ProRouteChildren: ProRouteChildren = {
  ProDirectoryRoute: ProDirectoryRoute,
  ProIndexRoute: ProIndexRoute,
  ProClientsInviteIdRoute: ProClientsInviteIdRouteWithChildren,
}

const ProRouteWithChildren = ProRoute._addFileChildren(ProRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  AppRoute: AppRouteWithChildren,
  CoachesRoute: CoachesRoute,
  ContactRoute: ContactRoute,
  CourtOrderLanguageRoute: CourtOrderLanguageRoute,
  FeaturesRoute: FeaturesRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  ProRoute: ProRouteWithChildren,
  ProCallbackRoute: ProCallbackRoute,
  SupportRoute: SupportRoute,
  TermsOfServiceRoute: TermsOfServiceRoute,
  AuthSignInRoute: AuthSignInRoute,
  AuthSignUpRoute: AuthSignUpRoute,
  ChildSupportCalculatorStateRoute: ChildSupportCalculatorStateRoute,
  CompareCompetitorRoute: CompareCompetitorRoute,
  LearnCoparentsRoute: LearnCoparentsRoute,
  LearnPractitionersRoute: LearnPractitionersRoute,
  ParentingPlanScheduleRoute: ParentingPlanScheduleRoute,
  ParentingPlanBuilderRoute: ParentingPlanBuilderRoute,
  PurchaseCancelRoute: PurchaseCancelRoute,
  PurchaseSuccessRoute: PurchaseSuccessRoute,
  AuthIndexRoute: AuthIndexRoute,
  ChildSupportCalculatorIndexRoute: ChildSupportCalculatorIndexRoute,
  CompareIndexRoute: CompareIndexRoute,
  ParentingPlanIndexRoute: ParentingPlanIndexRoute,
  PurchaseIndexRoute: PurchaseIndexRoute,
  AuthProSignInRoute: AuthProSignInRoute,
  AuthProSignUpRoute: AuthProSignUpRoute,
  RedeemProCodeRoute: RedeemProCodeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
